
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7boqA = parcelRequire("7boqA");


var $9wGTI = parcelRequire("9wGTI");








var $04jMq = parcelRequire("04jMq");

/**
 * @generated SignedSource<<c97c5b258e6679cdc97139884146f943>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba
const $4d55e7bf74ef8f79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
            "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
            "metadata": {},
            "name": "SpaceViewsControllerQuery",
            "operationKind": "query",
            "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$4d55e7bf74ef8f79$var$node.hash = "d33ab2e8cd8e66319f41302e5bdaa679";
var $4d55e7bf74ef8f79$export$2e2bcd8739ae039 = $4d55e7bf74ef8f79$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $9hlns = parcelRequire("9hlns");


var $bTdbD = parcelRequire("bTdbD");


var $4NZXC = parcelRequire("4NZXC");


var $5izcQ = parcelRequire("5izcQ");


var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");


var $bedQP = parcelRequire("bedQP");


var $3qtLb = parcelRequire("3qtLb");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");








var $k5uAm = parcelRequire("k5uAm");


var $lfFzM = parcelRequire("lfFzM");





var $6mKj3 = parcelRequire("6mKj3");


var $i28ZW = parcelRequire("i28ZW");


var $j3kZx = parcelRequire("j3kZx");


var $gCFsY = parcelRequire("gCFsY");


var $2vuKf = parcelRequire("2vuKf");


var $jMyy4 = parcelRequire("jMyy4");


var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");








var $1kHsc = parcelRequire("1kHsc");

const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, isSpaceAdmin: isSpaceAdmin })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $42omo.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                isSpaceAdmin: isSpaceAdmin
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        isSpaceAdmin
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};


const $5a12275e9873d32f$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));

const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("lCzuN"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("4L0Wn"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("b7lZG"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $aXWIB.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading, relatedContent: relatedContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(// @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    spaceKey, isLicensed);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $42omo.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $42omo.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $42omo.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $42omo.useState)(0);
    const [spaceViewsError, setSpaceViewsError] = (0, $42omo.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $42omo.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $4d55e7bf74ef8f79$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false),
        __callerPackage__: "@confluence/space-views"
    });
    const { canManageContent: canManageContentOp, loading: operationsLoading } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) || operationsLoading && (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const canManageContent = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? Boolean(canManageContentOp) : Boolean(data?.space?.currentUser?.isAdmin);
    const canManageContentOrSuperAdmin = canManageContent || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        isSpaceAdmin: canManageContent
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $k5uAm.useHoverPageCard)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $42omo.useState)(false);
    const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $42omo.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $42omo.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3qtLb.PageTree), {
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        canManageContentOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$RemovedSpotlightTarget, {
        name: "nav4-spotlight-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, relatedContent, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gCFsY.LazySpaceHoverPageCard), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
};
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, $5a12275e9873d32f$var$SpaceViewsControllerComponent({
        ...props
    }));






var $jzS7A = parcelRequire("jzS7A");





var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");

/* SpaceNavigationRelatedContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $2W0qg = parcelRequire("2W0qg");


var $6xdDU = parcelRequire("6xdDU");


var $5nBzc = parcelRequire("5nBzc");





var $7xVCs = parcelRequire("7xVCs");


var $1I9Gw = parcelRequire("1I9Gw");








var $3d6VZ = parcelRequire("3d6VZ");


var $f7B1p = parcelRequire("f7B1p");

var $41e6fe404d0f2514$exports = {};
$41e6fe404d0f2514$exports = new URL("loom.96da19c1.svg", import.meta.url).toString();


var $f4d501cf0149ba64$exports = {};
$f4d501cf0149ba64$exports = new URL("microsoft-teams.4206e18c.svg", import.meta.url).toString();


var $b6df249900984cef$exports = {};
$b6df249900984cef$exports = new URL("google-drive.3a58669c.svg", import.meta.url).toString();


var $9d3782c3b842cfbc$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    Action["IGNORE"] = "IGNORE";
    return Action;
}({});
const $9d3782c3b842cfbc$export$f0c7a43b2eefe22f = {
    LOOM: 'loom',
    MICROSOFT_TEAMS: 'teams',
    GOOGLE_DRIVE: 'gdrive'
};
const $9d3782c3b842cfbc$export$fcdafa222e2a08e2 = Object.values($9d3782c3b842cfbc$export$f0c7a43b2eefe22f);
const $9d3782c3b842cfbc$export$defe15004d994007 = {
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM]: (0, (/*@__PURE__*/$parcel$interopDefault($41e6fe404d0f2514$exports))),
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT_TEAMS]: (0, (/*@__PURE__*/$parcel$interopDefault($f4d501cf0149ba64$exports))),
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE]: (0, (/*@__PURE__*/$parcel$interopDefault($b6df249900984cef$exports)))
};
const $9d3782c3b842cfbc$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'teams.microsoft.com',
        product: 'Microsoft Teams',
        productKey: 'microsoftTeams',
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f4d501cf0149ba64$exports)))
    }
];
function $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url) {
    return $9d3782c3b842cfbc$export$51b10001420b4ba3.find((entry)=>url.includes(entry.pattern));
}
function $9d3782c3b842cfbc$export$39b141cbf41f04f3(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.productKey ?? 'link';
}
function $9d3782c3b842cfbc$export$82cacbc9ddf6b54e(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.iconUrl ?? '';
}


// name` values from `search.configuration.thirdPartyProducts
var $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME = /*#__PURE__*/ function(SEARCH_THIRD_PARTY_CONNECTOR_NAME) {
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["GOOGLE_DRIVE"] = "google-drive-connector";
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["MICROSOFT_TEAMS"] = "microsoft-teams-connector";
    return SEARCH_THIRD_PARTY_CONNECTOR_NAME;
}($dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME || {});
const $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION = 'SearchThirdPartyAuthConfiguration';
const $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY = `
query SearchThirdPartyAuthConfiguration($cloudId: ID!) {
	search {
		configuration(cloudId: $cloudId) {
			thirdPartyProducts {
				name
				isUserOAuthed
				outboundAuthUrl
				providerId
			}
		}
	}
}
`.trim();
const $dddab7bf95955fb3$var$filterAuthenticationStatus = (merged)=>{
    const authenticatedServices = {};
    const unauthenticatedServices = {};
    Object.entries(merged).forEach(([product, status])=>{
        if (status.isAuthenticated) authenticatedServices[product] = status;
        else unauthenticatedServices[product] = status;
    });
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices
    };
};
const $dddab7bf95955fb3$var$getLoomAuthStatus = async ()=>{
    try {
        const loomUserStatus = await (0, $3d6VZ.getAuthState)();
        return {
            isAuthenticated: loomUserStatus !== undefined && loomUserStatus !== 'NOT_FOUND'
        };
    } catch (e) {
        return {
            isAuthenticated: false,
            error: e instanceof Error ? e : new Error('Failed to fetch Loom auth status')
        };
    }
};
async function $dddab7bf95955fb3$var$fetchSearchThirdPartyProducts(cloudId) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'atl-attribution': JSON.stringify({
                    product: 'Confluence Cloud',
                    service: 'confluence-frontend'
                }),
                ...window['GLOBAL_AGG_REGION_STEERING_HINT'] ? {
                    'Atl-Edge-Region-Hint': window['GLOBAL_AGG_REGION_STEERING_HINT']
                } : {}
            },
            body: JSON.stringify({
                query: $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY,
                variables: {
                    cloudId: cloudId
                },
                operationName: $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const products = json.data?.search?.configuration?.thirdPartyProducts ?? [];
        return {
            products: products
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch search third-party configuration')
        };
    }
}
function $dddab7bf95955fb3$var$authStatusForSearchConnector(products, connectorName, fetchError) {
    const outboundAuthUrl = $dddab7bf95955fb3$var$outboundAuthUrlForConnector(products, connectorName);
    if (fetchError) return {
        isAuthenticated: false,
        error: fetchError,
        outboundAuthUrl: outboundAuthUrl
    };
    const matches = products.filter((p)=>p.name === connectorName);
    if (matches.length === 0) return {
        isAuthenticated: false,
        outboundAuthUrl: outboundAuthUrl
    };
    return {
        isAuthenticated: matches.some((p)=>p.isUserOAuthed),
        outboundAuthUrl: outboundAuthUrl
    };
}
function $dddab7bf95955fb3$var$outboundAuthUrlForConnector(products, connectorName) {
    const match = products.find((p)=>p.name === connectorName);
    return match?.outboundAuthUrl;
}
const $dddab7bf95955fb3$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const [mergedByProduct, setMergedByProduct] = (0, $42omo.useState)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const productsKey = products.join(',');
    const stableProductsRef = (0, $42omo.useRef)(products);
    if (stableProductsRef.current.join(',') !== productsKey) stableProductsRef.current = products;
    const refetch = (0, $42omo.useCallback)(async ()=>{
        const products = stableProductsRef.current;
        if (products.length === 0) {
            setMergedByProduct(null);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const merged = {};
            let searchProducts = [];
            let searchFetchError;
            if (products.includes((0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS) || products.includes((0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).GOOGLE_DRIVE)) {
                const searchResult = await $dddab7bf95955fb3$var$fetchSearchThirdPartyProducts(cloudId);
                if ('error' in searchResult) searchFetchError = searchResult.error;
                else searchProducts = searchResult.products;
            }
            for (const product of products)switch(product){
                case (0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).LOOM:
                    merged[(0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).LOOM] = await $dddab7bf95955fb3$var$getLoomAuthStatus();
                    break;
                case (0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS:
                    merged[(0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProducts, "microsoft-teams-connector", searchFetchError);
                    break;
                case (0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).GOOGLE_DRIVE:
                    merged[(0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).GOOGLE_DRIVE] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProducts, "google-drive-connector", searchFetchError);
                    break;
            }
            setMergedByProduct(merged);
        } finally{
            setIsLoading(false);
        }
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    const { authenticatedServices: authenticatedServices, unauthenticatedServices: unauthenticatedServices } = (0, $42omo.useMemo)(()=>{
        if (mergedByProduct == null) return {
            authenticatedServices: {},
            unauthenticatedServices: {}
        };
        return $dddab7bf95955fb3$var$filterAuthenticationStatus(mergedByProduct);
    }, [
        mergedByProduct
    ]);
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices,
        isLoading: isLoading,
        refetch: refetch
    };
};


/* ReviewContentSuggestionsModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ /* eslint-disable @atlassian/perf-linting/no-chain-state-updates */ /* eslint-disable @atlassian/perf-linting/no-expensive-computations-in-render */ 



var $jTxSS = parcelRequire("jTxSS");











var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $9zIwY = parcelRequire("9zIwY");


var $fnaPh = parcelRequire("fnaPh");


var $cO1el = parcelRequire("cO1el");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");



var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");










var $eG1e2 = parcelRequire("eG1e2");


var $8jHAi = parcelRequire("8jHAi");


var $jdPfT = parcelRequire("jdPfT");


var $7gpC4 = parcelRequire("7gpC4");





var $7aA9P = parcelRequire("7aA9P");


var $lsxnT = parcelRequire("lsxnT");


var $gqqjz = parcelRequire("gqqjz");




/* SuggestionMovePopup.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























var $lGgRw = parcelRequire("lGgRw");


var $bCECL = parcelRequire("bCECL");


var $4M98y = parcelRequire("4M98y");

/**
 * @generated SignedSource<<55e3b6bd911631caed95d5747e1febfc>>
 * @relayHash 7c0e4d8486e54ba6e102ec5009505b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f
const $190e7a369505d2bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7c0e4d8486e54ba6e102ec5009505b19",
            "id": "3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,title}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,title}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,title}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,title}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,title}}}"
        }
    };
}();
$190e7a369505d2bf$var$node.hash = "503b371610f42e1634360824bac2cefe";
var $190e7a369505d2bf$export$2e2bcd8739ae039 = $190e7a369505d2bf$var$node;








const $877d8332f9570d6f$var$ContentTitlesQuery = (0, $190e7a369505d2bf$export$2e2bcd8739ae039);
const $877d8332f9570d6f$export$7610585fadab893e = (contentIds)=>{
    const ids = (0, $42omo.useMemo)(()=>{
        const unique = [
            ...new Set(contentIds)
        ].filter(Boolean);
        return unique;
    }, [
        contentIds
    ]);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($877d8332f9570d6f$var$ContentTitlesQuery, {
        variables: {
            ids: ids
        },
        skip: ids.length === 0,
        __callerPackage__: "@confluence/space-curation"
    });
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById } = (0, $42omo.useMemo)(()=>{
        const titlesMap = new Map();
        const metaMap = new Map();
        const typedGroups = [
            {
                nodes: data?.pageContent ?? null,
                type: 'page'
            },
            {
                nodes: data?.folderContent ?? null,
                type: 'folder'
            },
            {
                nodes: data?.whiteboardContent ?? null,
                type: 'whiteboard'
            },
            {
                nodes: data?.databaseContent ?? null,
                type: 'database'
            },
            {
                nodes: data?.embedContent ?? null,
                type: 'embed'
            }
        ];
        for (const { nodes: nodes, type: type } of typedGroups){
            for (const node of nodes?.nodes ?? [])if (node?.id != null) {
                const title = node.title ?? '';
                titlesMap.set(node.id, title);
                metaMap.set(node.id, {
                    title: title,
                    type: type
                });
            }
        }
        return {
            titlesByContentId: titlesMap,
            contentMetaById: metaMap
        };
    }, [
        data
    ]);
    const isLoading = ids.length > 0 && loading;
    return {
        titlesByContentId: titlesByContentId,
        contentMetaById: contentMetaById,
        isLoading: isLoading
    };
};





const $e9fbe7b264ec157f$export$3e0409b11e4da6d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.25 0C8.76904 0 9.26676 0.206236 9.63379 0.573242L12.9268 3.86621C13.2938 4.23324 13.5 4.73096 13.5 5.25V8H12V6H8.25C7.83579 6 7.5 5.66421 7.5 5.25V1.5H3.5C3.22386 1.5 3 1.72386 3 2V14C3 14.2761 3.22386 14.5 3.5 14.5H6V16H3.5C2.39543 16 1.5 15.1046 1.5 14V2C1.5 0.895431 2.39543 0 3.5 0H8.25ZM9 4.5H11.4395L9 2.06055V4.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.5819 12.3067C14.8222 12.6013 14.8048 13.036 14.5302 13.3106L11.7802 16.0606L10.7196 15.0001L12.1893 13.5303L7.74988 13.5303L7.74988 12.0303L12.1893 12.0303L10.7196 10.5606L11.7802 9.50006L14.5302 12.2501L14.5819 12.3067Z",
        fill: "currentColor"
    }));


const $e4c0d2b6b6e18559$var$styles = {
    movePopupContent: "_1yt4utpp _1bsb1178",
    searchHint: "_1yt4u2gc _syaz1rpy",
    moveButtonOpen: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    fallbackSectionLabel: "_1yt41b66",
    fallbackParentRow: "_zulp12x7 _1yt4u2gc _2rko1mok _1e0c1txw _4cvr1h6o _1bsb1osq _bfhk1j28 _irr31dpa _1di6fcek",
    fallbackParentTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf _y3gnv2br",
    fallbackParentIcon: "_1o9zidpf",
    spinnerContainer: "_1yt4utpp _1e0c1txw _1bah1h6o"
};
const $e4c0d2b6b6e18559$var$i18n = (0, $aXWIB.defineMessages)({
    moveButton: {
        id: "space-curation.review-content-suggestions-modal.move-button",
        defaultMessage: "Move"
    },
    moveToTitle: {
        id: "space-curation.review-content-suggestions-modal.move-to-title",
        defaultMessage: "Move to"
    },
    searchHint: {
        id: "space-curation.review-content-suggestions-modal.move-search-hint",
        defaultMessage: "Search"
    },
    suggested: {
        id: "space-curation.review-content-suggestions-modal.move-suggested",
        defaultMessage: "Suggested"
    }
});
const $e4c0d2b6b6e18559$var$FallbackParentRow = ({ parentId: parentId, meta: meta, title: title, onMoveItemClick: onMoveItemClick })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        onMoveItemClick(parentId);
    }, [
        onMoveItemClick,
        parentId
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
        key: parentId,
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentRow,
        onClick: handleClick,
        testId: `suggestion-move-fallback-parent-${parentId}`
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentIcon,
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $bCECL.ContentIcon), {
        type: meta?.type ?? 'page'
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentTitle
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, meta?.title ?? title)));
};
const $e4c0d2b6b6e18559$export$de484dae570b7c31 = ({ suggestionId: suggestionId, spaceKey: spaceKey, isOpen: isOpen, onOpenChange: onOpenChange, onMoveSuggestion: onMoveSuggestion, fallbackParents: fallbackParents, currentParentId: currentParentId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const filteredFallbackParents = (0, $42omo.useMemo)(()=>(fallbackParents ?? []).filter((id)=>id !== currentParentId), [
        fallbackParents,
        currentParentId
    ]);
    const fallbackParentIdStrings = (0, $42omo.useMemo)(()=>filteredFallbackParents.map(String), [
        filteredFallbackParents
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoading } = (0, $877d8332f9570d6f$export$7610585fadab893e)(isOpen ? fallbackParentIdStrings : []);
    const handleMoveItemClick = (0, $42omo.useCallback)((idOrAri)=>{
        const str = String(idOrAri);
        const rawId = str.includes('/') ? str.split('/').pop() ?? str : str;
        const numId = Number(rawId);
        if (!rawId || isNaN(numId)) return;
        onMoveSuggestion(suggestionId, numId);
        onOpenChange(false);
    }, [
        onMoveSuggestion,
        onOpenChange,
        suggestionId
    ]);
    const renderFallbackParentList = ()=>{
        if (isLoading) return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $e4c0d2b6b6e18559$var$styles.spinnerContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: "small"
        }));
        const accessibleParents = filteredFallbackParents.filter((parentId)=>contentMetaById.has(String(parentId)));
        if (accessibleParents.length === 0) return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $e4c0d2b6b6e18559$var$styles.searchHint
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, formatMessage($e4c0d2b6b6e18559$var$i18n.searchHint)));
        return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $e4c0d2b6b6e18559$var$styles.fallbackSectionLabel
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest",
            weight: "semibold"
        }, formatMessage($e4c0d2b6b6e18559$var$i18n.suggested))), accessibleParents.map((parentId)=>/*#__PURE__*/ $42omo.createElement($e4c0d2b6b6e18559$var$FallbackParentRow, {
                key: parentId,
                parentId: parentId,
                meta: contentMetaById.get(String(parentId)),
                title: titlesByContentId.get(String(parentId)),
                onMoveItemClick: handleMoveItemClick
            })));
    };
    const fallbackParentRows = isOpen && filteredFallbackParents.length > 0 ? renderFallbackParentList() : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e4c0d2b6b6e18559$var$styles.searchHint
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, formatMessage($e4c0d2b6b6e18559$var$i18n.searchHint)));
    return /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>onOpenChange(false),
        placement: "bottom-start",
        zIndex: 800,
        content: ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $e4c0d2b6b6e18559$var$styles.movePopupContent
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
                weight: "bold"
            }, formatMessage($e4c0d2b6b6e18559$var$i18n.moveToTitle)), /*#__PURE__*/ $42omo.createElement((0, $4M98y.ContentTreeSearchBase), {
                spaceKey: spaceKey ?? '',
                onItemClick: handleMoveItemClick,
                contentId: "",
                placeholder: formatMessage($e4c0d2b6b6e18559$var$i18n.searchHint)
            }, fallbackParentRows)),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)(isOpen && $e4c0d2b6b6e18559$var$styles.moveButtonOpen)
            }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: ()=>/*#__PURE__*/ $42omo.createElement((0, $e9fbe7b264ec157f$export$3e0409b11e4da6d2), null),
                label: formatMessage($e4c0d2b6b6e18559$var$i18n.moveButton),
                onClick: ()=>onOpenChange(!isOpen),
                testId: `review-content-suggestion-move-button-${suggestionId}`
            }))
    });
};










const $55e1c5eec5b4b224$var$i18n = (0, $aXWIB.defineMessages)({
    successFlagTitle: {
        id: "space-curation.suggestion-actions.success.title",
        defaultMessage: "{count, plural, one {{count} item added to space} other {{count} items added to space}}"
    },
    successFlagDescription: {
        id: "space-curation.suggestion-actions.success.description",
        defaultMessage: "Your selected content has been added to this space."
    },
    errorFlagTitle: {
        id: "space-curation.suggestion-actions.error.title",
        defaultMessage: "Failed to add items to space"
    },
    errorFlagDescription: {
        id: "space-curation.suggestion-actions.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $55e1c5eec5b4b224$export$c9239e53ef385494 = ({ spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const submitActions = async (allSuggestions, selectedIds, rejectedIds, { showFlags: showFlags = true } = {})=>{
        if (!spaceKey) return false;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $9d3782c3b842cfbc$export$e19cd5f9376f8cee).ACCEPT : rejectedIds.has(s.id) ? (0, $9d3782c3b842cfbc$export$e19cd5f9376f8cee).REJECT : (0, $9d3782c3b842cfbc$export$e19cd5f9376f8cee).IGNORE
            }));
        try {
            await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    actions: actions
                })
            });
            if (showFlags) flags?.showSuccessFlag({
                id: 'space-navigation.suggestion-actions.success',
                title: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagTitle, {
                    count: selectedIds.size
                }),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
            return true;
        } catch  {
            if (showFlags) flags?.showErrorFlag({
                id: 'space-navigation.suggestion-actions.error',
                title: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagTitle),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
            return false;
        }
    };
    return {
        submitActions: submitActions
    };
};



/* SuggestionHoverCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $2Nwuj = parcelRequire("2Nwuj");


var $8tdj3 = parcelRequire("8tdj3");





var $5tmwS = parcelRequire("5tmwS");














const $ba5ec4d78670abb9$var$i18n = (0, $aXWIB.defineMessages)({
    hoverCardFallbackDescription: {
        id: "space-curation.review-content-suggestions-modal.hover-card-fallback-description",
        defaultMessage: "Open this item in a new tab to view it in {product}."
    },
    openHoverCardSuggestion: {
        id: "space-curation.review-content-suggestions-modal.open-hover-card-suggestion",
        defaultMessage: "Open item"
    },
    hoverCardTitleLinkAriaLabel: {
        id: "space-curation.review-content-suggestions-modal.hover-card-title-link-aria-label",
        defaultMessage: "{title}, opens in new tab"
    },
    productGoogleDocs: {
        id: "space-curation.review-content-suggestions-modal.product-google-docs.no-translate",
        defaultMessage: "Google Docs"
    },
    productGoogleSheets: {
        id: "space-curation.review-content-suggestions-modal.product-google-sheets.no-translate",
        defaultMessage: "Google Sheets"
    },
    productGoogleSlides: {
        id: "space-curation.review-content-suggestions-modal.product-google-slides.no-translate",
        defaultMessage: "Google Slides"
    },
    productGoogleDrive: {
        id: "space-curation.review-content-suggestions-modal.product-google-drive.no-translate",
        defaultMessage: "Google Drive"
    },
    productLoom: {
        id: "space-curation.review-content-suggestions-modal.product-loom.no-translate",
        defaultMessage: "Loom"
    },
    productMicrosoftTeams: {
        id: "space-curation.review-content-suggestions-modal.product-microsoft-teams.no-translate",
        defaultMessage: "Microsoft Teams"
    },
    productLink: {
        id: "space-curation.review-content-suggestions-modal.product-link",
        defaultMessage: "Link"
    },
    groupHoverCardItemCount: {
        id: "space-curation.review-content-suggestions-modal.group-hover-card-item-count",
        defaultMessage: "{count, plural, one {# item} other {# items}}"
    }
});
const $ba5ec4d78670abb9$var$PRODUCT_LABEL_MESSAGES = {
    googleDocs: $ba5ec4d78670abb9$var$i18n.productGoogleDocs,
    googleSheets: $ba5ec4d78670abb9$var$i18n.productGoogleSheets,
    googleSlides: $ba5ec4d78670abb9$var$i18n.productGoogleSlides,
    googleDrive: $ba5ec4d78670abb9$var$i18n.productGoogleDrive,
    loom: $ba5ec4d78670abb9$var$i18n.productLoom,
    microsoftTeams: $ba5ec4d78670abb9$var$i18n.productMicrosoftTeams,
    link: $ba5ec4d78670abb9$var$i18n.productLink
};
function $ba5ec4d78670abb9$var$getProductLabelMessage(productKey) {
    return $ba5ec4d78670abb9$var$PRODUCT_LABEL_MESSAGES[productKey];
}
const $ba5ec4d78670abb9$var$styles = {
    hoverCard: "_2rko1mok _1yt4pxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb5x59 _bfhk1j9a _16qs130s",
    hoverCardContent: "_p12f1osq _1ul9idpf",
    hoverCardTitle: "_p12f1osq",
    hoverCardTitleLinkWrapper: "_zulp1b66 _1e0c1txw _4cvr1y6m _1ul9idpf",
    hoverCardTitleLinkTextWrapper: "_1reo15vq _18m915vq _1ul9idpf",
    hoverCardTitleLinkIcon: "_1e0c1txw _4cvr1h6o _1pfhv77o _tzy4idpf _16l4kb7n",
    hoverCardDescription: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _syazazsu _1yyj11wp _p12f1osq",
    hoverCardFooter: "_195g1410 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1q51u2gc _syazazsu",
    hoverCardIcon: "_1bsbdlk8 _4t3idlk8 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf"
};
const $ba5ec4d78670abb9$export$bf0a0c07cf58248c = ({ suggestion: suggestion })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const productKey = (0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(suggestion.url);
    const iconUrl = (0, $9d3782c3b842cfbc$export$82cacbc9ddf6b54e)(suggestion.url);
    const product = formatMessage($ba5ec4d78670abb9$var$getProductLabelMessage(productKey));
    const description = suggestion.description?.trim() ? suggestion.description : formatMessage($ba5ec4d78670abb9$var$i18n.hoverCardFallbackDescription, {
        product: product
    }); // @ts-ignore
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150",
        xcss: $ba5ec4d78670abb9$var$styles.hoverCard,
        testId: "review-content-suggestion-hover-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardIcon,
        "aria-hidden": "true"
    }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
        src: iconUrl,
        width: "14",
        height: "14",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: ""
            }),
        role: "presentation"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.025",
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ba5ec4d78670abb9$var$styles.hoverCardTitle, $ba5ec4d78670abb9$var$styles.hoverCardTitleLinkWrapper)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardTitleLinkTextWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: suggestion.url,
        target: "_blank",
        "aria-label": formatMessage($ba5ec4d78670abb9$var$i18n.hoverCardTitleLinkAriaLabel, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "medium",
        color: "color.text.accent.blue"
    }, suggestion.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardTitleLinkIcon,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardIcon,
        "aria-hidden": "true"
    }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
        src: iconUrl,
        width: "14",
        height: "14",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: ""
            }),
        role: "presentation"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle"
    }, product)));
};
const $ba5ec4d78670abb9$export$89a7edf0c311b93 = ({ title: title, itemCount: itemCount })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150",
        xcss: $ba5ec4d78670abb9$var$styles.hoverCard,
        testId: "review-content-suggestion-group-hover-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardIcon,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.025",
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba5ec4d78670abb9$var$styles.hoverCardTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "medium",
        color: "color.text.accent.blue"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($ba5ec4d78670abb9$var$i18n.groupHoverCardItemCount, {
        count: itemCount
    })))));
};






var $hBkCm = parcelRequire("hBkCm");



const $b0a504e05d35a946$export$b1532bcf7c9b2548 = (spaceKey)=>{
    const [groups, setGroups] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $42omo.useState)(false);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        if (!spaceKey) {
            setGroups([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`, {
                method: 'GET'
            });
            const data = await response.json();
            setGroups(data.suggestions ?? []);
            setIsSuppressed(false);
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        groups: groups,
        isLoading: isLoading,
        refetch: refetch,
        isSuppressed: isSuppressed
    };
};


/* ContentPreviewPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 







var $248197f38f8adff3$exports = {};
$248197f38f8adff3$exports = new URL("preview-no-selection.14e43eee.svg", import.meta.url).toString();


var $457bd44acde81868$exports = {};
$457bd44acde81868$exports = new URL("content-preview-squiggle.027b5d84.svg", import.meta.url).toString();


const $32647b41ad829cc7$var$styles = {
    container: "_kqswh2mm _4t3i1osq",
    squiggleWrapper: "_1pfhv47k _6rth1ejb",
    skeletonBarFull: "_1bsbr354 _4t3iftgi _bfhkysee",
    skeletonBarShortWrapper: "_1pfhutpp",
    skeletonBarShort: "_1bsbmhvn _4t3iftgi _bfhkysee",
    skeletonBarBottom: "_1bsb1dqv _4t3ii2wt _bfhkysee _kqswstnw _94n5ze3t _1ltvze3t"
};
const $32647b41ad829cc7$export$5589fb4f49509a9b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.container,
        testId: "content-preview-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($248197f38f8adff3$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.squiggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($457bd44acde81868$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "84",
        height: "15"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShortWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShort
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarBottom
    }));
};






var $eSUdr = parcelRequire("eSUdr");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");

const $444ac254b74f8acb$var$CreatorInfoQuery = (0, $eSUdr.default)`query useCreatorInfoQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;
const $444ac254b74f8acb$export$949ad1c6f51713db = (accountIds)=>{
    const [creatorInfoMap, setCreatorInfoMap] = (0, $42omo.useState)(new Map());
    const uniqueIds = (0, $42omo.useMemo)(()=>[
            ...new Set(accountIds.filter(Boolean))
        ], [
        accountIds
    ]);
    (0, $42omo.useEffect)(()=>{
        if (uniqueIds.length === 0) {
            setCreatorInfoMap(new Map());
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                    query: $444ac254b74f8acb$var$CreatorInfoQuery,
                    variables: {
                        accountIds: uniqueIds
                    },
                    interopApolloAggClient: true,
                    __callerPackage__: "@confluence/space-curation"
                });
                if (cancelled) return;
                error?.graphQLErrors?.forEach((e)=>(0, $7Sm4c.markErrorAsHandled)(e));
                const map = new Map();
                if (data?.users) {
                    for (const user of data.users)if (user?.accountId && user.name) map.set(user.accountId, {
                        displayName: user.name,
                        avatarUrl: user.picture || `/wiki/aa-avatar/${user.accountId}`
                    });
                }
                setCreatorInfoMap(map);
            } catch (err) {
                // Non-critical: preview will just not show author info
                if (err instanceof Error) (0, $7Sm4c.markErrorAsHandled)(err);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        uniqueIds
    ]);
    return creatorInfoMap;
};


var $42884bf60d912389$exports = {};
$42884bf60d912389$exports = new URL("preview-thumbnail-fallback.2f93bc33.svg", import.meta.url).toString();


/* SuggestionFeedbackModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");






var $fVUfS = parcelRequire("fVUfS");






var $9EtP6 = parcelRequire("9EtP6");








const $fdaa5fb91b997659$var$i18n = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "space-curation.suggestion-feedback-modal.title",
        defaultMessage: "Rate suggestion quality"
    },
    part1Header: {
        id: "space-curation.suggestion-feedback-modal.part1-header",
        defaultMessage: "Part 1: Core Content & Placement"
    },
    part2Header: {
        id: "space-curation.suggestion-feedback-modal.part2-header",
        defaultMessage: "Part 2: Context & Quality"
    },
    skipLabel: {
        id: "space-curation.suggestion-feedback-modal.skip-label",
        defaultMessage: "Skip / I do not know"
    },
    submitButton: {
        id: "space-curation.suggestion-feedback-modal.submit",
        defaultMessage: "Submit"
    },
    cancelButton: {
        id: "space-curation.suggestion-feedback-modal.cancel",
        defaultMessage: "Cancel"
    },
    topicalRelevanceTitle: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.title",
        defaultMessage: "Topical Relevance"
    },
    topicalRelevanceQuestion: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.question",
        defaultMessage: "Is the document about the same topic as the space?"
    },
    topicalRelevance3: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.3",
        defaultMessage: "Highly Relevant \u2013 Core part of this topic."
    },
    topicalRelevance2: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.2",
        defaultMessage: "Related \u2013 Shares the same theme but is tangential."
    },
    topicalRelevance1: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.1",
        defaultMessage: "Slightly Related \u2013 Only a small portion fits."
    },
    topicalRelevance0: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.0",
        defaultMessage: "Irrelevant \u2013 No logical connection."
    },
    placementTitle: {
        id: "space-curation.suggestion-feedback-modal.placement.title",
        defaultMessage: "Placement"
    },
    placementQuestion: {
        id: "space-curation.suggestion-feedback-modal.placement.question",
        defaultMessage: "Is this the right folder suggestion for this content?"
    },
    placement2: {
        id: "space-curation.suggestion-feedback-modal.placement.2",
        defaultMessage: "Perfect Fit \u2013 Exactly where it belongs."
    },
    placement1: {
        id: "space-curation.suggestion-feedback-modal.placement.1",
        defaultMessage: "Acceptable \u2013 Not the best spot, but makes sense."
    },
    placement0: {
        id: "space-curation.suggestion-feedback-modal.placement.0",
        defaultMessage: "Incorrect \u2013 Placement is confusing or wrong."
    },
    usefulnessTitle: {
        id: "space-curation.suggestion-feedback-modal.usefulness.title",
        defaultMessage: "Usefulness"
    },
    usefulnessQuestion: {
        id: "space-curation.suggestion-feedback-modal.usefulness.question",
        defaultMessage: "Would this doc actually help someone working in this space?"
    },
    usefulness4: {
        id: "space-curation.suggestion-feedback-modal.usefulness.4",
        defaultMessage: "Essential \u2013 Crucial; the space is incomplete without it."
    },
    usefulness3: {
        id: "space-curation.suggestion-feedback-modal.usefulness.3",
        defaultMessage: "Helpful \u2013 Adds clear value and saves time."
    },
    usefulness2: {
        id: "space-curation.suggestion-feedback-modal.usefulness.2",
        defaultMessage: "Neutral \u2013 Belongs there, but doesn't change much."
    },
    usefulness1: {
        id: "space-curation.suggestion-feedback-modal.usefulness.1",
        defaultMessage: "Not Very Useful \u2013 Low-value or \"fluff.\""
    },
    usefulness0: {
        id: "space-curation.suggestion-feedback-modal.usefulness.0",
        defaultMessage: "Counter-productive \u2013 Distracting or adds noise."
    },
    redundancyTitle: {
        id: "space-curation.suggestion-feedback-modal.redundancy.title",
        defaultMessage: "Redundancy (Uniqueness)"
    },
    redundancyQuestion: {
        id: "space-curation.suggestion-feedback-modal.redundancy.question",
        defaultMessage: "Does the doc add info not already in the space?"
    },
    redundancy3: {
        id: "space-curation.suggestion-feedback-modal.redundancy.3",
        defaultMessage: "Entirely New \u2013 Information not found elsewhere in the space."
    },
    redundancy2: {
        id: "space-curation.suggestion-feedback-modal.redundancy.2",
        defaultMessage: "Mostly New \u2013 Some overlap, but provides new insights."
    },
    redundancy1: {
        id: "space-curation.suggestion-feedback-modal.redundancy.1",
        defaultMessage: "High Overlap \u2013 Repeats most of what is already there."
    },
    redundancy0: {
        id: "space-curation.suggestion-feedback-modal.redundancy.0",
        defaultMessage: "Redundant \u2013 Information is already present (duplicate/near-duplicate)."
    },
    explainabilityTitle: {
        id: "space-curation.suggestion-feedback-modal.explainability.title",
        defaultMessage: "Explainability"
    },
    explainabilityQuestion: {
        id: "space-curation.suggestion-feedback-modal.explainability.question",
        defaultMessage: "Is it clear why this document was recommended for this space?"
    },
    explainability2: {
        id: "space-curation.suggestion-feedback-modal.explainability.2",
        defaultMessage: "Very Clear \u2013 I immediately see the connection."
    },
    explainability1: {
        id: "space-curation.suggestion-feedback-modal.explainability.1",
        defaultMessage: "Vaguely Clear \u2013 I can see a possible link, but it's weak."
    },
    explainability0: {
        id: "space-curation.suggestion-feedback-modal.explainability.0",
        defaultMessage: "Not Clear \u2013 The suggestion feels random or \"black box.\""
    },
    recencyTitle: {
        id: "space-curation.suggestion-feedback-modal.recency.title",
        defaultMessage: "Recency & Freshness"
    },
    recencyQuestion: {
        id: "space-curation.suggestion-feedback-modal.recency.question",
        defaultMessage: "How would you characterize the timeliness of this document?"
    },
    recency2: {
        id: "space-curation.suggestion-feedback-modal.recency.2",
        defaultMessage: "Current/Evergreen \u2013 Information is up-to-date or foundational (always useful)."
    },
    recency1: {
        id: "space-curation.suggestion-feedback-modal.recency.1",
        defaultMessage: "Historical Reference \u2013 Older but still holds some context or \"lesson learned\" value."
    },
    recency0: {
        id: "space-curation.suggestion-feedback-modal.recency.0",
        defaultMessage: "Obsolete \u2013 The information is expired, superseded, or no longer true."
    },
    permissionsPrivacyTitle: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.title",
        defaultMessage: "Permissions & Privacy"
    },
    permissionsPrivacyQuestion: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.question",
        defaultMessage: "Does it feel appropriate for this document to be surfaced here?"
    },
    permissionsPrivacy2: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.2",
        defaultMessage: "Appropriate \u2013 Safe for general viewing within the space's context."
    },
    permissionsPrivacy1: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.1",
        defaultMessage: "Questionable \u2013 Might contain semi-private info that feels \"odd\" to see."
    },
    permissionsPrivacy0: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.0",
        defaultMessage: "Inappropriate \u2013 Contains sensitive or private data that should not be surfaced."
    },
    additionalCommentsLabel: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.label",
        defaultMessage: "Additional comments (optional)"
    },
    additionalCommentsPlaceholder: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.placeholder",
        defaultMessage: "Share any other thoughts about this suggestion\u2026"
    }
});
const $fdaa5fb91b997659$var$FEEDBACK_QUESTIONS = [
    {
        key: 'topicalRelevance',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.topicalRelevanceTitle,
        question: $fdaa5fb91b997659$var$i18n.topicalRelevanceQuestion,
        options: [
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance0
            }
        ]
    },
    {
        key: 'placement',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.placementTitle,
        question: $fdaa5fb91b997659$var$i18n.placementQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.placement2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.placement1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.placement0
            }
        ]
    },
    {
        key: 'usefulness',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.usefulnessTitle,
        question: $fdaa5fb91b997659$var$i18n.usefulnessQuestion,
        options: [
            {
                value: 4,
                label: $fdaa5fb91b997659$var$i18n.usefulness4
            },
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.usefulness3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.usefulness2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.usefulness1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.usefulness0
            }
        ]
    },
    {
        key: 'redundancy',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.redundancyTitle,
        question: $fdaa5fb91b997659$var$i18n.redundancyQuestion,
        options: [
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.redundancy3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.redundancy2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.redundancy1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.redundancy0
            }
        ]
    },
    {
        key: 'explainability',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.explainabilityTitle,
        question: $fdaa5fb91b997659$var$i18n.explainabilityQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.explainability2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.explainability1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.explainability0
            }
        ]
    },
    {
        key: 'recency',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.recencyTitle,
        question: $fdaa5fb91b997659$var$i18n.recencyQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.recency2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.recency1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.recency0
            }
        ]
    },
    {
        key: 'permissionsPrivacy',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.permissionsPrivacyTitle,
        question: $fdaa5fb91b997659$var$i18n.permissionsPrivacyQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy0
            }
        ]
    }
];
const $fdaa5fb91b997659$var$styles = {
    partHeader: "_1q51pxbi _85i5u2gc _1doce4h9 _1il9nqa1 _1o3i1l7x _6rthu2gc",
    questionBlock: "_85i5pxbi",
    optionRow: "_zulpu2gc _2rko12b0 _v564ij15 _1rjc12x7 _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c1txw _4cvr1h6o _80omtlke _irr3i8nm",
    optionRowSelected: "_1h6dq98m _bfhk15s3 _irr3ufnl",
    optionRowDisabled: "_tzy42wxo _80om13gf _irr31j28",
    radioCircle: "_2rko1rr0 _189ee4h9 _1dqonqa1 _1h6d1ihb _1bsb7vkz _4t3i7vkz _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o",
    radioCircleSelected: "_1h6dq98m _bfhkjmqp",
    radioInnerDot: "_2rko1rr0 _1bsbi2wt _4t3ii2wt _bfhk5w2r",
    skipRow: "_1q511b66",
    additionalCommentsSection: "_1q51pxbi _85i5u2gc",
    modalBody: "_1rjcpxbi"
};
const $fdaa5fb91b997659$var$OptionRow = ({ label: label, value: value, questionKey: questionKey, isSelected: isSelected, isDisabled: isDisabled, onSelect: onSelect })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!isDisabled) onSelect(questionKey, value);
    }, [
        isDisabled,
        onSelect,
        questionKey,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        role: "radio",
        "aria-checked": isSelected,
        "aria-disabled": isDisabled,
        xcss: (0, $1Whri.cx)($fdaa5fb91b997659$var$styles.optionRow, isSelected && $fdaa5fb91b997659$var$styles.optionRowSelected, isDisabled && $fdaa5fb91b997659$var$styles.optionRowDisabled),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($fdaa5fb91b997659$var$styles.radioCircle, isSelected && $fdaa5fb91b997659$var$styles.radioCircleSelected)
    }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fdaa5fb91b997659$var$styles.radioInnerDot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small"
    }, label));
};
const $fdaa5fb91b997659$export$2eae41a486732e13 = ({ suggestion: suggestion, spaceId: spaceId, spaceKey: spaceKey, onClose: onClose, onSubmit: onSubmit })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [answers, setAnswers] = (0, $42omo.useState)(()=>Object.fromEntries($fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((q)=>[
                q.key,
                null
            ])));
    const [skipped, setSkipped] = (0, $42omo.useState)(()=>Object.fromEntries($fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((q)=>[
                q.key,
                false
            ])));
    const [additionalComments, setAdditionalComments] = (0, $42omo.useState)('');
    const handleSelectOption = (0, $42omo.useCallback)((questionKey, value)=>{
        setAnswers((prev)=>({
                ...prev,
                [questionKey]: value
            }));
    }, []);
    const handleToggleSkip = (0, $42omo.useCallback)((questionKey, checked)=>{
        setSkipped((prev)=>({
                ...prev,
                [questionKey]: checked
            }));
        if (checked) setAnswers((prev)=>({
                ...prev,
                [questionKey]: null
            }));
    }, []);
    const handleSubmit = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'submitted',
                actionSubject: 'suggestionFeedback',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    userId: userId,
                    suggestionAri: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(suggestion.url),
                    topicalRelevance: answers.topicalRelevance,
                    placement: answers.placement,
                    usefulness: answers.usefulness,
                    redundancy: answers.redundancy,
                    explainability: answers.explainability,
                    recency: answers.recency,
                    permissionsPrivacy: answers.permissionsPrivacy,
                    additionalComments: additionalComments.trim() || undefined
                }
            }
        }).fire();
        onSubmit?.();
        onClose();
    }, [
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        suggestion,
        answers,
        additionalComments,
        onClose,
        onSubmit,
        userId
    ]);
    const questionsWithPartHeaders = (0, $42omo.useMemo)(()=>$fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((question, index)=>({
                ...question,
                showPartHeader: index === 0 || question.part !== $fdaa5fb91b997659$var$FEEDBACK_QUESTIONS[index - 1].part
            })), []);
    const handleSkipChange = (0, $42omo.useCallback)((questionKey)=>(e)=>handleToggleSkip(questionKey, e.target.checked), [
        handleToggleSkip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, formatMessage($fdaa5fb91b997659$var$i18n.modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fdaa5fb91b997659$var$styles.modalBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, questionsWithPartHeaders.map((question)=>{
        const isSkipped = skipped[question.key];
        const selectedValue = answers[question.key];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: question.key
        }, question.showPartHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $fdaa5fb91b997659$var$styles.partHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, question.part === 1 ? formatMessage($fdaa5fb91b997659$var$i18n.part1Header) : formatMessage($fdaa5fb91b997659$var$i18n.part2Header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $fdaa5fb91b997659$var$styles.questionBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "semibold"
        }, formatMessage(question.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage(question.question)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            role: "radiogroup",
            "aria-label": formatMessage(question.title)
        }, // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        question.options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdaa5fb91b997659$var$OptionRow, {
                key: option.value,
                label: formatMessage(option.label),
                value: option.value,
                questionKey: question.key,
                isSelected: !isSkipped && selectedValue === option.value,
                isDisabled: isSkipped,
                onSelect: handleSelectOption
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $fdaa5fb91b997659$var$styles.skipRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            label: formatMessage($fdaa5fb91b997659$var$i18n.skipLabel),
            isChecked: isSkipped,
            onChange: handleSkipChange(question.key)
        })))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fdaa5fb91b997659$var$styles.additionalCommentsSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold"
    }, formatMessage($fdaa5fb91b997659$var$i18n.additionalCommentsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        value: additionalComments,
        onChange: (e)=>setAdditionalComments(e.target.value),
        placeholder: formatMessage($fdaa5fb91b997659$var$i18n.additionalCommentsPlaceholder),
        maxLength: 500,
        minimumRows: 3
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage($fdaa5fb91b997659$var$i18n.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSubmit
    }, formatMessage($fdaa5fb91b997659$var$i18n.submitButton))));
};




var $e0221f708694947b$exports = {};
$e0221f708694947b$exports = new URL("connect-arrow.348feda5.png", import.meta.url).toString();


var $663a371f840cd308$exports = {};
$663a371f840cd308$exports = new URL("preview-background.b2903e0c.svg", import.meta.url).toString();


var $1ad7fb4b19a283df$exports = {};
$1ad7fb4b19a283df$exports = new URL("content-preview-sparkle.2c80a83f.svg", import.meta.url).toString();


const $e0ce0b995765d610$var$PRODUCT_DISPLAY_NAMES = {
    'google-drive': 'Google Drive',
    loom: 'Loom',
    'microsoft-teams': 'Microsoft Teams'
};
const $e0ce0b995765d610$var$getPreviewSourceFromProductKey = (productKey)=>{
    switch(productKey){
        case 'googleDocs':
        case 'googleSheets':
        case 'googleSlides':
        case 'googleDrive':
            return 'google-drive';
        case 'loom':
            return 'loom';
        case 'microsoftTeams':
            return 'microsoft-teams';
        default:
            return undefined;
    }
};
const $e0ce0b995765d610$var$SUGGESTION_PREVIEW_DWELL_MS = 500;
function $e0ce0b995765d610$var$useSuggestionPreviewAnalytics({ spaceId: spaceId, spaceKey: spaceKey, suggestion: suggestion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverStartRef = (0, $42omo.useRef)(null);
    const previewTimeoutRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (previewTimeoutRef.current) clearTimeout(previewTimeoutRef.current);
        };
    }, []);
    const startPreviewAnalytics = (0, $42omo.useCallback)(()=>{
        hoverStartRef.current = Date.now();
        previewTimeoutRef.current = setTimeout(()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'previewed',
                    actionSubject: 'suggestion',
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        suggestionId: suggestion.id,
                        suggestionUrl: suggestion.url,
                        suggestedParentId: suggestion.parentId,
                        sourceType: (0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(suggestion.url),
                        previewDwellMs: Date.now() - (hoverStartRef.current ?? Date.now())
                    }
                }
            }).fire();
            previewTimeoutRef.current = null;
        }, $e0ce0b995765d610$var$SUGGESTION_PREVIEW_DWELL_MS);
    }, [
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        suggestion
    ]);
    const cancelPreviewAnalytics = (0, $42omo.useCallback)(()=>{
        if (previewTimeoutRef.current) {
            clearTimeout(previewTimeoutRef.current);
            previewTimeoutRef.current = null;
        }
        hoverStartRef.current = null;
    }, []);
    return {
        startPreviewAnalytics: startPreviewAnalytics,
        cancelPreviewAnalytics: cancelPreviewAnalytics
    };
}
const $e0ce0b995765d610$var$i18n = (0, $aXWIB.defineMessages)({
    addItemsToSpace: {
        id: "space-curation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    bringTogetherTitle: {
        id: "space-curation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "space-curation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Add these suggestions and they'll be organized in this space."
    },
    openSuggestion: {
        id: "space-curation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title}"
    },
    feedbackButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.feedback-button-label",
        defaultMessage: "Give feedback on {title}"
    },
    evalButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.eval-button-label",
        defaultMessage: "Eval"
    },
    untitled: {
        id: "space-curation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    loading: {
        id: "space-curation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading"
    },
    submitting: {
        id: "space-curation.review-content-suggestions-modal.submitting",
        defaultMessage: "Adding..."
    },
    rejectSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reject-suggestion",
        defaultMessage: "Reject {title}"
    },
    resetSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reset-suggestion",
        defaultMessage: "Restore suggestion"
    },
    addToThisSpace: {
        id: "space-curation.review-content-suggestions-modal.add-to-this-space",
        defaultMessage: "Add to this Space"
    },
    dismissItems: {
        id: "space-curation.review-content-suggestions-modal.dismiss-items",
        defaultMessage: "Dismiss Items"
    }
});
const $e0ce0b995765d610$var$styles = {
    layout: "_2rkopb1k _1reo15vq _18m915vq _1bsbtfvk _4t3i1kvu",
    leftPanel: "_zulppxbi _1reo15vq _18m915vq _18zroahv _1o9zidpf _i0dl1gdv _1e0c1txw _2lx21bp4 _1q51oahv _85i5oahv",
    rightPanel: "_1reo15vq _18m915vq _16jlkb7n _bfhkvuon _kqswh2mm _5fbcpb1k _1einpb1k",
    closeButtonWrapper: "_kqswstnw _154ipxbi _1xi2pxbi _1pby9y44",
    groupListScrollArea: "_16jlkb7n _18m91wug _1fjgglyw _1tkeidpf",
    groupCard: "_2rko1mok _1reo15vq _18m915vq _1h6d1l7x _189ee4h9 _1dqonqa1",
    groupCardHovering: "_kqswh2mm _1pby1fw0",
    groupRow: "_zulpu2gc _1q51pxbi _85i51b66 _bozgpxbi _y4tipxbi",
    groupIconSlot: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    groupTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    itemsList: "_1reoewfl _18m9ewfl _18zru2gc _1tkeidpf _85i5u2gc",
    itemRowContainer: "_v564mvc0 _2rko1mok _1reo15vq _18m915vq _kqswh2mm _1pbyidpf _1bsb1osq _irr31dpa",
    itemRowContainerHovered: "_1pbykb7n",
    itemRowContainerCardHovered: "_bfhk1dpa",
    portalHoverCard: "_v5649fok _kqsw1n9t _1pby9y44 _lcxvglyw _tzy4idpf _t9ecqjb0",
    portalHoverCardVisible: "_tzy4kb7n _lcxv1wug _t9ec1h7a",
    suggestionLinkWrapper: "_zulputpp _16jlkb7n _1ul9idpf _1e0c1txw _4cvr1h6o",
    suggestionLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _2lx21bp4 _4cvr1y6m _1n261q9c _1ul9idpf _syazi7uo _16jlkb7n _9oik1r31 _1bnx8stv _jf4cnqa1 _9oiki7uo",
    suggestionDescription: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    suggestionIconSlot: "_2rko1qi0 _1bsb1ylp _4t3i1ylp _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bfhki8nm",
    suggestionTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    leftPanelHeader: "",
    contentPreviewContainer: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _4t3i1osq _kqswh2mm",
    contentPreviewUnit: "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbe0nm _4t3i1lk4",
    contentPreviewDecorativeBackground: "_kqswstnw _154i1crf",
    contentPreviewIllustration: "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o",
    contentPreviewIconTopLeft: "_zulpu2gc _kqswstnw _154i1ul9 _1ltv1gi9 _1e0c1txw _2lx21bp4 _4cvr1h6o _1pby3bl2",
    contentPreviewIconBottomRight: "_kqswstnw _94n51ylp _1xi28am7 _1e0c1txw _2lx21bp4 _4cvr1h6o _1pby3bl2",
    contentPreviewSparkle: "_kqswstnw _154i1gi9 _1xi28am7 _t9ecaceq _1pby3bl2",
    contentPreviewGoogleDriveIcon: "_19it1vhv _2rko1qi0 _1reo15vq _18m915vq _t9ec1b5u _bfhkvuon _1bsb14no _4t3i14no _1e0c1txw _4cvr1h6o _1bah1h6o",
    contentPreviewLoomIcon: "_t9ec1brj _ahbqvbgk",
    contentPreviewArrowTopLeft: "_t9ec1q10 _12l2kqtd",
    contentPreviewDarkBlueBox: "_kqswstnw _1bsbjwe6 _4t3i1sot _bfhk1856 _t9ec16qr _94n514id _1ltv14id",
    contentPreviewCard: "_1reoewfl _18m9ewfl _1e0c1txw _1bsbsb0t _4t3i1feq _bfhkvuon _kqswh2mm",
    contentPreviewImageContainer: "_1reo15vq _18m915vq _1bsb1osq",
    contentPreviewImageFallback: "_1bsb1osq _4t3i1j4a _bfhkysee _1e0c1txw _4cvr1h6o _1bah1h6o",
    contentPreviewProductLabel: "_kqswstnw _94n51ejb _1ltvv47k",
    contentPreviewCardPadding: "_1yt4v47k _85i51ejb _1bsb1osq",
    itemRow: "_zulp1b66 _1rjcutpp _18zru2gc _irr31dpa",
    unselectedLink: "_9oik1r31 _1bnxglyw _jf4cnqa1",
    loadingOverlay: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbtfvk _4t3ikvcq",
    feedbackIconButton: "_2rko12b0 _1yt41b66 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr3plhp",
    thumbsDownButton: "_2rko12b0 _1yt41b66 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr3plhp",
    itemRowContainerRejected: "_bfhkby5v"
};
// Estimated max height of the hover cards (in px) used for vertical clamping
const $e0ce0b995765d610$var$HOVER_CARD_HEIGHT = 200; // Must match the width set in SuggestionHoverCard styles
const $e0ce0b995765d610$var$HOVER_CARD_WIDTH = 340;
const $e0ce0b995765d610$var$HOVER_CARD_OFFSET = 8;
const $e0ce0b995765d610$var$computePosition = (anchorRect, placement)=>{
    const top = window.innerHeight - anchorRect.top < $e0ce0b995765d610$var$HOVER_CARD_HEIGHT + $e0ce0b995765d610$var$HOVER_CARD_OFFSET ? window.innerHeight - $e0ce0b995765d610$var$HOVER_CARD_HEIGHT - $e0ce0b995765d610$var$HOVER_CARD_OFFSET : anchorRect.top;
    const preferredLeft = placement === 'left-start' ? anchorRect.left - $e0ce0b995765d610$var$HOVER_CARD_WIDTH - $e0ce0b995765d610$var$HOVER_CARD_OFFSET : anchorRect.right + $e0ce0b995765d610$var$HOVER_CARD_OFFSET;
    const left = Math.min(Math.max(preferredLeft, $e0ce0b995765d610$var$HOVER_CARD_OFFSET), window.innerWidth - $e0ce0b995765d610$var$HOVER_CARD_WIDTH - $e0ce0b995765d610$var$HOVER_CARD_OFFSET);
    return {
        top: top,
        left: left
    };
}; // Delay before showing the card, preventing accidental triggers when scanning the list (matches page tree's HOVER_DELAY_TIME)
const $e0ce0b995765d610$var$HOVER_CARD_SHOW_DELAY_MS = 300; // Delay before hiding the card, giving the user time to move the mouse onto it (matches page tree's CLOSE_DELAY_TIME)
const $e0ce0b995765d610$var$HOVER_CARD_HIDE_DELAY_MS = 400;
const $e0ce0b995765d610$var$ESCAPE_KEY = 'Escape'; // Module-level state for coordinating hover cards across multiple hook instances.
// When one row's card shows, any previously active card is hidden immediately so only
// one card is ever visible at a time.
let $e0ce0b995765d610$var$sharedHideTimer = null;
let $e0ce0b995765d610$var$sharedShowTimer = null; // Callback that immediately hides the currently active card instance
let $e0ce0b995765d610$var$activeHideCallback = null; // Tracks which hook instance owns the pending show timer so unmount cleanup
// doesn't cancel a different instance's timer (real bug: unrelated unmount
// would silently suppress another row's hover card from appearing)
let $e0ce0b995765d610$var$sharedShowTimerOwner = null;
const $e0ce0b995765d610$var$clearSharedHideTimer = ()=>{
    if ($e0ce0b995765d610$var$sharedHideTimer !== null) {
        clearTimeout($e0ce0b995765d610$var$sharedHideTimer);
        $e0ce0b995765d610$var$sharedHideTimer = null;
    }
};
const $e0ce0b995765d610$var$clearSharedShowTimer = ()=>{
    if ($e0ce0b995765d610$var$sharedShowTimer !== null) {
        clearTimeout($e0ce0b995765d610$var$sharedShowTimer);
        $e0ce0b995765d610$var$sharedShowTimer = null;
        $e0ce0b995765d610$var$sharedShowTimerOwner = null;
    }
}; // Exported for tests to reset module-level state between test cases
const $e0ce0b995765d610$export$f8787da88a883447 = ()=>{
    $e0ce0b995765d610$var$clearSharedHideTimer();
    $e0ce0b995765d610$var$clearSharedShowTimer();
    $e0ce0b995765d610$var$activeHideCallback = null;
    $e0ce0b995765d610$var$sharedShowTimerOwner = null;
};
const $e0ce0b995765d610$var$useHoverCardPortal = (placement = 'right-start')=>{
    const ref = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [position, setPosition] = (0, $42omo.useState)(null); // Tracks whether the mouse is hovering the card portal so the anchor row can be highlighted
    const [isCardHovered, setIsCardHovered] = (0, $42omo.useState)(false); // Immediate (non-delayed) hide used when another instance takes over
    const forceHide = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
        setPosition(null);
        setIsCardHovered(false);
    }, []); // Compute and update position from the anchor's current bounding rect
    const updatePosition = (0, $42omo.useCallback)(()=>{
        if (ref.current) setPosition($e0ce0b995765d610$var$computePosition(ref.current.getBoundingClientRect(), placement));
    }, [
        placement
    ]); // Recompute position once the card becomes visible (anchor may have moved during show delay)
    (0, $42omo.useEffect)(()=>{
        if (isVisible) updatePosition();
    }, [
        isVisible,
        updatePosition
    ]);
    const instanceId = (0, $42omo.useRef)(Symbol('hover-card-instance'));
    const show = (0, $42omo.useCallback)(()=>{
        // Cancel any pending delayed hide or show
        $e0ce0b995765d610$var$clearSharedHideTimer();
        $e0ce0b995765d610$var$clearSharedShowTimer(); // Force-hide the currently active card from a different instance
        if ($e0ce0b995765d610$var$activeHideCallback && $e0ce0b995765d610$var$activeHideCallback !== forceHide) $e0ce0b995765d610$var$activeHideCallback();
         // Delay showing so quick mouse scans don't trigger cards
        $e0ce0b995765d610$var$sharedShowTimerOwner = instanceId.current;
        $e0ce0b995765d610$var$sharedShowTimer = setTimeout(()=>{
            $e0ce0b995765d610$var$sharedShowTimer = null;
            $e0ce0b995765d610$var$sharedShowTimerOwner = null;
            $e0ce0b995765d610$var$activeHideCallback = forceHide;
            setIsVisible(true);
        }, $e0ce0b995765d610$var$HOVER_CARD_SHOW_DELAY_MS);
    }, [
        forceHide
    ]);
    const hide = (0, $42omo.useCallback)(()=>{
        // Cancel any pending show timer (mouse left before delay elapsed)
        $e0ce0b995765d610$var$clearSharedShowTimer(); // Delay hide so mouse can travel from anchor onto the card without it disappearing
        $e0ce0b995765d610$var$sharedHideTimer = setTimeout(()=>{
            $e0ce0b995765d610$var$sharedHideTimer = null;
            if ($e0ce0b995765d610$var$activeHideCallback === forceHide) $e0ce0b995765d610$var$activeHideCallback = null;
            forceHide();
        }, $e0ce0b995765d610$var$HOVER_CARD_HIDE_DELAY_MS);
    }, [
        forceHide
    ]); // Cancel the delayed hide when mouse enters the card itself
    const onCardMouseEnter = (0, $42omo.useCallback)(()=>{
        $e0ce0b995765d610$var$clearSharedHideTimer();
        setIsCardHovered(true);
    }, []); // Hide when mouse leaves the card
    const onCardMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsCardHovered(false);
        hide();
    }, [
        hide
    ]); // Dismiss on Escape key
    (0, $42omo.useEffect)(()=>{
        if (!isVisible) return;
        const handleEscKey = (e)=>{
            if (e.key === $e0ce0b995765d610$var$ESCAPE_KEY) {
                $e0ce0b995765d610$var$clearSharedHideTimer();
                $e0ce0b995765d610$var$clearSharedShowTimer();
                if ($e0ce0b995765d610$var$activeHideCallback === forceHide) $e0ce0b995765d610$var$activeHideCallback = null;
                forceHide();
            }
        };
        document.addEventListener('keydown', handleEscKey);
        return ()=>{
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [
        isVisible,
        forceHide
    ]); // On unmount, only clean up timers/state that this instance owns
    (0, $42omo.useEffect)(()=>{
        // Capture the instance ID at effect creation time so the cleanup closure
        // references a stable value (direct .current access in cleanup is a lint error)
        const currentInstanceId = instanceId.current;
        return ()=>{
            // Only cancel the show timer if this instance scheduled it
            if ($e0ce0b995765d610$var$sharedShowTimerOwner === currentInstanceId) $e0ce0b995765d610$var$clearSharedShowTimer();
            if ($e0ce0b995765d610$var$activeHideCallback === forceHide) {
                $e0ce0b995765d610$var$clearSharedHideTimer();
                $e0ce0b995765d610$var$activeHideCallback = null;
            }
        };
    }, [
        forceHide
    ]);
    return {
        ref: ref,
        isVisible: isVisible,
        isCardHovered: isCardHovered,
        position: position,
        show: show,
        hide: hide,
        onCardMouseEnter: onCardMouseEnter,
        onCardMouseLeave: onCardMouseLeave
    };
};
const $e0ce0b995765d610$var$SuggestionItemRow = ({ spaceId: spaceId, spaceKey: spaceKey, suggestion: suggestion, isSelected: isSelected, isRejected: isRejected, hasFeedbackBeenSubmitted: hasFeedbackBeenSubmitted, onFeedbackSubmitted: onFeedbackSubmitted, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onHoverCardVisibilityChange: onHoverCardVisibilityChange, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const iconUrl = (0, $9d3782c3b842cfbc$export$82cacbc9ddf6b54e)(suggestion.url);
    const { ref: ref, isVisible: isVisible, isCardHovered: isCardHovered, position: position, show: show, hide: hide, onCardMouseEnter: onCardMouseEnter, onCardMouseLeave: onCardMouseLeave } = $e0ce0b995765d610$var$useHoverCardPortal('right-start'); // isRowHovered tracks immediate mouse-over state for row UI elements (Move button, row highlight)
    // without waiting for the card's 300ms show delay
    const [isRowHovered, setIsRowHovered] = (0, $42omo.useState)(false);
    const { startPreviewAnalytics: startPreviewAnalytics, cancelPreviewAnalytics: cancelPreviewAnalytics } = $e0ce0b995765d610$var$useSuggestionPreviewAnalytics({
        spaceId: spaceId,
        spaceKey: spaceKey,
        suggestion: suggestion
    });
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $42omo.useState)(false);
    const isFeedbackModalOpenRef = (0, $42omo.useRef)(false);
    const [isMovePopupOpen, setIsMovePopupOpen] = (0, $42omo.useState)(false);
    const isMovePopupOpenRef = (0, $42omo.useRef)(false);
    const handleShow = ()=>{
        if (isRejected) return;
        setIsRowHovered(true);
        onSuggestionHover?.(suggestion);
        if (!isSelected) return;
        if (isMovePopupOpenRef.current || isFeedbackModalOpenRef.current) return;
        show();
        onHoverCardVisibilityChange(true);
        startPreviewAnalytics();
    };
    const handleHide = ()=>{
        if (isRejected) return;
        setIsRowHovered(false); // Intentionally not clearing hoveredSuggestion on mouse leave —
        // the preview panel persists the last hovered item to avoid flickering
        hide();
        onHoverCardVisibilityChange(false);
        cancelPreviewAnalytics();
    };
    const handleMovePopupOpenChange = (open)=>{
        isMovePopupOpenRef.current = open;
        setIsMovePopupOpen(open);
        if (open) handleHide();
    };
    (0, $42omo.useEffect)(()=>{
        if (!isSelected) {
            handleHide();
            handleMovePopupOpenChange(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: ref,
        xcss: (0, $1Whri.cx)($e0ce0b995765d610$var$styles.itemRowContainer, !isRejected && (isRowHovered || isCardHovered) && $e0ce0b995765d610$var$styles.itemRowContainerHovered, !isRejected && isCardHovered && $e0ce0b995765d610$var$styles.itemRowContainerCardHovered, isRejected && $e0ce0b995765d610$var$styles.itemRowContainerRejected),
        onMouseEnter: handleShow,
        onMouseLeave: handleHide,
        onFocusCapture: handleShow,
        onBlur: (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            handleHide();
        },
        testId: `review-content-suggestion-row-${suggestion.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.itemRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.suggestionLinkWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: isRejected ? {
            opacity: 0.5
        } : undefined,
        xcss: $e0ce0b995765d610$var$styles.suggestionIconSlot,
        "aria-hidden": "true"
    }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
        src: iconUrl,
        width: "20",
        height: "20",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: ""
            }),
        role: "presentation"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: suggestion.url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.openSuggestion, {
            title: suggestion.title
        }),
        xcss: (0, $1Whri.cx)($e0ce0b995765d610$var$styles.suggestionLink, !isSelected && $e0ce0b995765d610$var$styles.unselectedLink)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.suggestionTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 1,
        color: isRejected ? 'color.text.disabled' : undefined
    }, suggestion.title)), suggestion.explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.suggestionDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 1,
        size: "small",
        color: "color.text.subtlest"
    }, suggestion.explanation)))), !hasFeedbackBeenSubmitted && (0, $6mKj3.expVal)('cc-space-curation-feedback-survey', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $e0ce0b995765d610$var$styles.feedbackIconButton,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            isFeedbackModalOpenRef.current = true;
            handleHide();
            setIsFeedbackModalOpen(true);
        },
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.feedbackButtonLabel, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($e0ce0b995765d610$var$i18n.evalButtonLabel))), !isRejected && (isRowHovered || isMovePopupOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e4c0d2b6b6e18559$export$de484dae570b7c31), {
        suggestionId: suggestion.id,
        spaceKey: spaceKey,
        isOpen: isMovePopupOpen,
        onOpenChange: handleMovePopupOpenChange,
        onMoveSuggestion: onMoveSuggestion,
        fallbackParents: suggestion.fallbackParents,
        currentParentId: suggestion.parentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $e0ce0b995765d610$var$styles.thumbsDownButton,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        },
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.rejectSuggestion, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }))), isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))),
        label: formatMessage($e0ce0b995765d610$var$i18n.resetSuggestion, {
            title: suggestion.title
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        }
    })), !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        isChecked: isSelected,
        onChange: ()=>onToggleSelectItem(suggestion.id)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isFeedbackModalOpen && (0, $6mKj3.expVal)('cc-space-curation-feedback-survey', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdaa5fb91b997659$export$2eae41a486732e13), {
        suggestion: suggestion,
        spaceId: spaceId,
        spaceKey: spaceKey,
        onClose: ()=>{
            isFeedbackModalOpenRef.current = false;
            setIsFeedbackModalOpen(false);
        },
        onSubmit: ()=>onFeedbackSubmitted?.(suggestion.id)
    })), isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($e0ce0b995765d610$var$styles.portalHoverCard, isVisible && $e0ce0b995765d610$var$styles.portalHoverCardVisible),
        style: {
            top: position.top,
            left: position.left
        },
        testId: "review-content-suggestion-hover-card-portal",
        onMouseEnter: onCardMouseEnter,
        onMouseLeave: onCardMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba5ec4d78670abb9$export$bf0a0c07cf58248c), {
        suggestion: suggestion
    })), document.body));
};
const $e0ce0b995765d610$var$SuggestionGroupRow = ({ parentTitle: parentTitle, parentType: parentType, suggestions: suggestions, isGroupSelected: isGroupSelected, selectedItems: selectedItems, rejectedItems: rejectedItems, spaceId: spaceId, spaceKey: spaceKey, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, submittedFeedbackIds: submittedFeedbackIds, onFeedbackSubmitted: onFeedbackSubmitted, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover })=>{
    const [isHoverCardVisible, setIsHoverCardVisible] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($e0ce0b995765d610$var$styles.groupCard, isHoverCardVisible && $e0ce0b995765d610$var$styles.groupCardHovering),
        onMouseEnter: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onMouseLeave: isGroupSelected ? ()=>onGroupHoverChange(parentId, false) : undefined,
        onFocusCapture: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onBlur: isGroupSelected ? (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) onGroupHoverChange(parentId, false);
        } : undefined,
        testId: `review-content-suggestion-group-card-${parentId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.groupRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        shouldWrap: false,
        grow: "fill",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.groupIconSlot
    }, parentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.groupTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium",
        maxLines: 1
    }, parentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        isChecked: isGroupSelected,
        onChange: ()=>toggleSelectGroup(suggestions)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.itemsList
    }, suggestions.map((suggestion)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$var$SuggestionItemRow, {
            key: suggestion.id,
            suggestion: suggestion,
            isSelected: selectedItems.has(suggestion.id),
            isRejected: rejectedItems.has(suggestion.id),
            spaceId: spaceId,
            hasFeedbackBeenSubmitted: submittedFeedbackIds.has(suggestion.id),
            onFeedbackSubmitted: onFeedbackSubmitted,
            spaceKey: spaceKey,
            onToggleSelectItem: onToggleSelectItem,
            onRejectItem: onRejectItem,
            onHoverCardVisibilityChange: setIsHoverCardVisible,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover
        }))));
};
const $e0ce0b995765d610$var$ModalLeftPanel = ({ groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, contentMetaById: contentMetaById, selectedItems: selectedItems, rejectedItems: rejectedItems, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, spaceId: spaceId, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [submittedFeedbackIds, setSubmittedFeedbackIds] = (0, $42omo.useState)(new Set());
    const handleFeedbackSubmitted = (0, $42omo.useCallback)((suggestionId)=>{
        setSubmittedFeedbackIds((prev)=>new Set([
                ...prev,
                suggestionId
            ]));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.250"
    }, [
        ...groupedSuggestionsWithTitles.entries()
    ].map(([parentId, { parentTitle: parentTitle, suggestions: groupSuggestions }])=>{
        const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
        const parentType = contentMetaById.get(String(parentId))?.type;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$var$SuggestionGroupRow, {
            key: parentId,
            parentTitle: parentTitle || formatMessage($e0ce0b995765d610$var$i18n.untitled),
            parentType: parentType,
            suggestions: groupSuggestions,
            isGroupSelected: isGroupSelected,
            selectedItems: selectedItems,
            rejectedItems: rejectedItems,
            parentId: parentId,
            toggleSelectGroup: toggleSelectGroup,
            onToggleSelectItem: toggleSelectItem,
            onRejectItem: onRejectItem,
            onGroupHoverChange: onGroupHoverChange,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover,
            spaceId: spaceId,
            submittedFeedbackIds: submittedFeedbackIds,
            onFeedbackSubmitted: handleFeedbackSubmitted,
            spaceKey: spaceKey
        });
    }));
};
const $e0ce0b995765d610$var$PreviewContent = ({ imageUrl: imageUrl, title: title, description: description, productIconUrl: productIconUrl, authorName: authorName, authorAvatarUrl: authorAvatarUrl })=>{
    const [imageError, setImageError] = (0, $42omo.useState)(false);
    const [avatarError, setAvatarError] = (0, $42omo.useState)(false);
    const [imageLoaded, setImageLoaded] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageContainer
    }, (!imageUrl || imageError || !imageLoaded) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($42884bf60d912389$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    })), imageUrl && !imageError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: imageUrl,
        alt: "",
        width: "100%",
        onLoad: ()=>setImageLoaded(true),
        onError: ()=>setImageError(true),
        style: {
            display: imageLoaded ? 'block' : 'none'
        }
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium",
        maxLines: 2
    }, productIconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: productIconUrl,
        alt: "",
        width: "16",
        height: "16",
        style: {
            verticalAlign: '-3px',
            marginRight: '6px'
        }
    }), title), authorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, authorAvatarUrl && !avatarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: authorAvatarUrl,
        alt: "",
        width: "16",
        height: "16",
        style: {
            borderRadius: '50%'
        },
        onError: ()=>setAvatarError(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, authorName)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 3
    }, description));
};
const $e0ce0b995765d610$var$ModalRightPanel = ({ previewSource: previewSource, previewImageUrl: previewImageUrl, previewTitle: previewTitle, previewDescription: previewDescription, previewProductIconUrl: previewProductIconUrl, previewAuthorName: previewAuthorName, previewAuthorAvatarUrl: previewAuthorAvatarUrl, onClose: onClose })=>{
    const showGoogleDrive = !previewSource || previewSource === 'google-drive';
    const showLoom = !previewSource || previewSource === 'loom';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.rightPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close",
        appearance: "subtle",
        onClick: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewUnit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDecorativeBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($663a371f840cd308$exports))),
        alt: "",
        "aria-hidden": "true"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewIllustration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDarkBlueBox
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewSparkle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1ad7fb4b19a283df$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "75",
        height: "83"
    })), showGoogleDrive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewIconTopLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewGoogleDriveIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b6df249900984cef$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "32",
        height: "32"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewArrowTopLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e0221f708694947b$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    }))), showLoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewIconBottomRight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewLoomIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($41e6fe404d0f2514$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "32",
        height: "32"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e0221f708694947b$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCardPadding
    }, previewSource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$var$PreviewContent, {
        key: previewImageUrl || previewTitle,
        imageUrl: previewImageUrl,
        title: previewTitle,
        description: previewDescription,
        productIconUrl: previewProductIconUrl,
        authorName: previewAuthorName,
        authorAvatarUrl: previewAuthorAvatarUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32647b41ad829cc7$export$5589fb4f49509a9b), null), previewSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewProductLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: previewProductIconUrl || (previewSource === 'loom' ? (0, (/*@__PURE__*/$parcel$interopDefault($41e6fe404d0f2514$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b6df249900984cef$exports)))),
        alt: "",
        width: "16",
        height: "16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, $e0ce0b995765d610$var$PRODUCT_DISPLAY_NAMES[previewSource])))))))));
};
const $e0ce0b995765d610$export$8a4b505874e89d07 = ({ spaceKey: spaceKey, spaceId: spaceId, onClose: onClose, onSaveSuccess: onSaveSuccess, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { groups: groups, isLoading: isFetchingSuggestions } = (0, $b0a504e05d35a946$export$b1532bcf7c9b2548)(spaceKey);
    const [suggestionOverrides, setSuggestionOverrides] = (0, $42omo.useState)(()=>new Map());
    const allSuggestions = (0, $42omo.useMemo)(()=>groups.flatMap((g)=>g.remoteObjects).map((s)=>{
            const override = suggestionOverrides.get(s.id);
            return override ? {
                ...s,
                ...override
            } : s;
        }), [
        groups,
        suggestionOverrides
    ]);
    const [selectedItems, setSelectedItems] = (0, $42omo.useState)(()=>new Set());
    const [rejectedItems, setRejectedItems] = (0, $42omo.useState)(()=>new Set());
    const [_isHoveringGroupList, setIsHoveringGroupList] = (0, $42omo.useState)(false);
    const [_hoveredParentId, setHoveredParentId] = (0, $42omo.useState)(null);
    const [hoveredSuggestion, setHoveredSuggestion] = (0, $42omo.useState)(null);
    const [previewParentId, setPreviewParentId] = (0, $42omo.useState)(groups[0]?.parentId);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const parentIds = (0, $42omo.useMemo)(()=>{
        const overriddenIds = [
            ...suggestionOverrides.values()
        ].map((o)=>String(o.parentId));
        return [
            ...new Set([
                ...groups.map((g)=>String(g.parentId)),
                ...overriddenIds
            ])
        ];
    }, [
        groups,
        suggestionOverrides
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoadingTitles } = (0, $877d8332f9570d6f$export$7610585fadab893e)(parentIds);
    const { submitActions: submitActions } = (0, $55e1c5eec5b4b224$export$c9239e53ef385494)({
        spaceKey: spaceKey,
        flags: flags
    }); // Fetch creator display names and avatar URLs for all suggestions
    const creatorAccountIds = (0, $42omo.useMemo)(()=>allSuggestions.map((s)=>s.creatorAccountId).filter(Boolean), [
        allSuggestions
    ]);
    const creatorInfoMap = (0, $444ac254b74f8acb$export$949ad1c6f51713db)(creatorAccountIds);
    const isLoading = isFetchingSuggestions || isLoadingTitles || isSubmitting;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openTimestampRef = (0, $42omo.useRef)(Date.now());
    const dismissMethodRef = (0, $42omo.useRef)('close_button');
    const sourceTypes = (0, $42omo.useMemo)(()=>Array.from(new Set(allSuggestions.map((s)=>(0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(s.url)))), [
        allSuggestions
    ]);
    const mountValuesRef = (0, $42omo.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        suggestionCount: allSuggestions.length,
        sourceTypes: sourceTypes,
        renderedSuggestions: allSuggestions.map((s, rankIndex)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(s.url),
                rankIndex: rankIndex,
                suggestedParentId: s.parentId
            })),
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $42omo.useEffect)(()=>{
        const { spaceId: si, spaceKey: sk, suggestionCount: sc, sourceTypes: st, renderedSuggestions: rs, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionCount: sc,
                    sourceTypes: st
                }
            }
        }).fire();
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestions: rs
                }
            }
        }).fire();
    }, []);
    (0, $42omo.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') dismissMethodRef.current = 'escape';
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    const handleClose = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    suggestionCountAtDismiss: allSuggestions.length,
                    dismissMethod: dismissMethodRef.current,
                    timeInModuleMs: Date.now() - openTimestampRef.current
                }
            }
        }).fire();
        if (rejectedItems.size > 0) {
            const rejectedSuggestions = allSuggestions.filter((s)=>rejectedItems.has(s.id));
            await submitActions(rejectedSuggestions, new Set(), rejectedItems, {
                showFlags: false
            });
        }
        dismissMethodRef.current = 'close_button';
        onClose();
    };
    const handleAdd = async ()=>{
        setIsSubmitting(true);
        try {
            const ok = await submitActions(allSuggestions, selectedItems, rejectedItems);
            if (ok) {
                const suggestionAcceptancePayload = (s)=>({
                        suggestionId: s.id,
                        suggestionUrl: s.url,
                        sourceType: (0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(s.url),
                        targetFolderId: s.parentId,
                        folderWasRecommended: true
                    });
                const acceptedSuggestions = allSuggestions.filter((s)=>selectedItems.has(s.id)).map(suggestionAcceptancePayload);
                const dismissedSuggestions = allSuggestions.filter((s)=>!selectedItems.has(s.id)).map(suggestionAcceptancePayload);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'accepted',
                        actionSubject: 'suggestions',
                        source: 'containerNavigation',
                        attributes: {
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            count: acceptedSuggestions.length,
                            acceptedSuggestions: acceptedSuggestions,
                            dismissedSuggestions: dismissedSuggestions
                        }
                    }
                }).fire();
                await onSaveSuccess();
            }
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleMoveSuggestion = (0, $42omo.useCallback)((suggestionId, newParentId)=>{
        setSuggestionOverrides((prev)=>new Map(prev).set(suggestionId, {
                parentId: newParentId
            }));
        setPreviewParentId(newParentId);
    }, []);
    const groupedSuggestionsWithTitles = (0, $42omo.useMemo)(()=>{
        const originalGroups = new Map();
        const newGroups = new Map();
        const originalParentIds = new Set(groups.map((g)=>g.parentId));
        allSuggestions.forEach((suggestion)=>{
            const pid = suggestion.parentId;
            const isNewGroup = !originalParentIds.has(pid);
            const target = isNewGroup ? newGroups : originalGroups;
            const existing = target.get(pid);
            if (existing) target.set(pid, {
                ...existing,
                suggestions: [
                    ...existing.suggestions,
                    suggestion
                ]
            });
            else target.set(pid, {
                parentTitle: titlesByContentId.get(String(pid)) ?? '',
                suggestions: [
                    suggestion
                ]
            });
        });
        return new Map([
            ...originalGroups.entries(),
            ...newGroups.entries()
        ]);
    }, [
        allSuggestions,
        titlesByContentId,
        groups
    ]);
    (0, $42omo.useEffect)(()=>{
        if (previewParentId === undefined || groups.length === 0) {
            setPreviewParentId(groups[0]?.parentId);
            return;
        }
        if (!groupedSuggestionsWithTitles.has(previewParentId)) setPreviewParentId(groups[0]?.parentId);
    }, [
        groups,
        previewParentId,
        groupedSuggestionsWithTitles
    ]);
    const handleGroupHoverChange = (parentId, isHovering)=>{
        setIsHoveringGroupList(isHovering);
        setHoveredParentId(isHovering ? parentId : null);
        if (isHovering) setPreviewParentId(parentId);
    };
    const toggleSelectItem = (itemId)=>{
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else next.add(itemId);
            return next;
        });
    };
    const toggleRejectItem = (itemId)=>{
        setRejectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else {
                // Selecting a reject removes the item from selected
                next.add(itemId);
                setSelectedItems((prevSelected)=>{
                    const nextSelected = new Set(prevSelected);
                    nextSelected.delete(itemId);
                    return nextSelected;
                });
            }
            return next;
        });
    };
    const toggleSelectGroup = (groupSuggestions)=>{
        const allSelected = groupSuggestions.every((s)=>selectedItems.has(s.id));
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            groupSuggestions.forEach((s)=>{
                if (allSelected) next.delete(s.id);
                else next.add(s.id);
            });
            return next;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: handleClose,
        width: "auto"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.loadingOverlay,
        testId: "review-content-suggestions-modal-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        label: isSubmitting ? formatMessage($e0ce0b995765d610$var$i18n.submitting) : formatMessage($e0ce0b995765d610$var$i18n.loading)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $e0ce0b995765d610$var$styles.layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.leftPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.leftPanelHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e0ce0b995765d610$var$styles.groupListScrollArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$var$ModalLeftPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        contentMetaById: contentMetaById,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        toggleSelectGroup: toggleSelectGroup,
        toggleSelectItem: toggleSelectItem,
        onRejectItem: toggleRejectItem,
        onGroupHoverChange: handleGroupHoverChange,
        onMoveSuggestion: handleMoveSuggestion,
        onSuggestionHover: setHoveredSuggestion,
        spaceId: spaceId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "end",
        xcss: $e0ce0b995765d610$var$styles.addButtonRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: selectedItems.size > 0 ? 'primary' : 'subtle',
        onClick: ()=>void handleAdd(),
        isDisabled: selectedItems.size === 0
    }, selectedItems.size > 0 ? formatMessage($e0ce0b995765d610$var$i18n.addItemsToSpace, {
        count: selectedItems.size
    }) : formatMessage($e0ce0b995765d610$var$i18n.addToThisSpace)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$var$ModalRightPanel, {
        onClose: handleClose,
        previewImageUrl: hoveredSuggestion?.iconUrl,
        previewTitle: hoveredSuggestion?.title,
        previewDescription: hoveredSuggestion?.description,
        previewProductIconUrl: hoveredSuggestion ? (0, $9d3782c3b842cfbc$export$82cacbc9ddf6b54e)(hoveredSuggestion.url) : undefined,
        previewSource: hoveredSuggestion ? $e0ce0b995765d610$var$getPreviewSourceFromProductKey((0, $9d3782c3b842cfbc$export$39b141cbf41f04f3)(hoveredSuggestion.url)) : undefined,
        previewAuthorName: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.displayName : undefined,
        previewAuthorAvatarUrl: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.avatarUrl : undefined
    })));
};
const $e0ce0b995765d610$export$c9ce09b966ffa4f7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0ce0b995765d610$export$8a4b505874e89d07, {
            ...props,
            flags: flags
        }));










const $862814430f69e6aa$export$ba9e49b520a30a69 = (spaceKey)=>{
    const [count, setCount] = (0, $42omo.useState)(0);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $42omo.useState)(false);
    const fetchCount = (0, $42omo.useCallback)(async ()=>{
        if (!spaceKey) {
            setCount(0);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions/count`, {
                method: 'GET'
            });
            const text = await response.text();
            setCount(parseInt(text, 10) || 0);
            setIsSuppressed(false);
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        fetchCount();
    }, [
        fetchCount
    ]);
    return {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed
    };
};


/* StackedContentTypeIcons.tsx generated by @compiled/babel-plugin v0.36.1 */ 










const $83a4f2079077de9f$var$ICON_SIZE = {
    small: 16,
    medium: 20,
    large: 28
};
const $83a4f2079077de9f$var$i18n = (0, $aXWIB.defineMessages)({
    loomIconAlt: {
        id: "space-curation.stacked-content-type-icons.loom-icon-alt",
        defaultMessage: "Loom icon"
    },
    googleDriveIconAlt: {
        id: "space-curation.stacked-content-type-icons.google-drive-icon-alt",
        defaultMessage: "Google Drive icon"
    }
});
const $83a4f2079077de9f$var$styles = {
    wrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    iconSlotFirst: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqidpf _kqswh2mm _1pbyb4wl _t9ec4yfw",
    iconSlotSecond: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqr5cr _kqswh2mm _1pbykb7n _t9ec14e9"
};
const $83a4f2079077de9f$export$98526f0dffd4f41b = ({ variant: variant = 'small', testId: testId = 'stacked-content-type-icons' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const size = $83a4f2079077de9f$var$ICON_SIZE[variant];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $83a4f2079077de9f$var$styles.wrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $83a4f2079077de9f$var$styles.iconSlotFirst,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($41e6fe404d0f2514$exports))),
        width: size,
        height: size,
        alt: formatMessage($83a4f2079077de9f$var$i18n.loomIconAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $83a4f2079077de9f$var$styles.iconSlotSecond,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b6df249900984cef$exports))),
        width: size,
        height: size,
        alt: formatMessage($83a4f2079077de9f$var$i18n.googleDriveIconAlt)
    })));
};



/* ThirdPartyAuthentication.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $3uVVG = parcelRequire("3uVVG");




























var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");

const $cb6359e6e5610133$var$i18n = (0, $aXWIB.defineMessages)({
    moreOptions: {
        id: "space-curation.close-menu.more-options",
        defaultMessage: "More options"
    },
    dismiss: {
        id: "space-curation.close-menu.dismiss",
        defaultMessage: "Dismiss"
    },
    neverShowAgain: {
        id: "space-curation.close-menu.never-show-again",
        defaultMessage: "Never show again"
    }
});
const $cb6359e6e5610133$export$4805c143e51c45b4 = ({ onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isOpen: isOpen,
        onOpenChange: ({ isOpen: nextIsOpen })=>setIsOpen(nextIsOpen),
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: intl.formatMessage($cb6359e6e5610133$var$i18n.moreOptions),
                isTooltipDisabled: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>{
            setIsOpen(false);
            onDismiss();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>{
            setIsOpen(false);
            onNeverShowAgain();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.neverShowAgain))));
};





const $4a7342ec49ac4fa7$export$2c06ec8998ac1741 = ()=>{
    const dismissAction = async (neverShowAgain)=>{
        await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?neverShowAgain=${neverShowAgain ?? false}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    return {
        dismissAction: dismissAction
    };
};


/* GoogleDriveIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 









const $cc473e89fe15c58b$var$ICON_SIZE = {
    small: 16,
    large: 28
};
const $cc473e89fe15c58b$var$i18n = (0, $aXWIB.defineMessages)({
    googleDriveIconAlt: {
        id: "space-curation.space-navigation.google-drive-icon.alt",
        defaultMessage: "Google Drive icon"
    }
});
const $cc473e89fe15c58b$var$styles = {
    googleDriveIcon: "_2rko12b0 _19itia51 _1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _ahbqidpf _2hwxu2gc _kqswh2mm _s7n4jp4b _1pbyb4wl"
};
const $cc473e89fe15c58b$export$e16bd899bb4eebf9 = ({ variant: variant = 'small', testId: testId = 'google-drive-icon' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const size = $cc473e89fe15c58b$var$ICON_SIZE[variant];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $cc473e89fe15c58b$var$styles.googleDriveIcon,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b6df249900984cef$exports))),
        width: size,
        height: size,
        alt: formatMessage($cc473e89fe15c58b$var$i18n.googleDriveIconAlt)
    }));
};



const $225bc84a53ca9cda$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1yt4utpp _bfhk1s93 _19pku2gc _kqswh2mm",
    topRow: "_1e0c1txw _4cvr1y6m _1bah1yb4 _otyr1b66",
    mainAction: "_zulp1b66 _1yt4ze3t _1e0c1txw _2lx21bp4 _4cvr1y6m _bfhk1j28 _1bsb1osq _y3gnv2br"
};
const $225bc84a53ca9cda$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "space-curation.space-navigation.third-party-auth.title",
        defaultMessage: "Make the most of docs, sheets, slides, and folders"
    },
    beta: {
        id: "space-curation.space-navigation.third-party-auth.beta",
        defaultMessage: "Beta"
    },
    connect: {
        id: "space-curation.space-navigation.third-party-auth.connect",
        defaultMessage: "Connect Google Drive"
    },
    dismiss: {
        id: "space-curation.space-navigation.third-party-auth.dismiss",
        defaultMessage: "Dismiss"
    },
    successFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.success-title",
        defaultMessage: "Google Drive connected"
    },
    successFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.success-description",
        defaultMessage: "We're on it! Rovo is looking for documents for this space, check back later."
    },
    cancelledFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-title",
        defaultMessage: "Connection cancelled"
    },
    cancelledFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-description",
        defaultMessage: "Couldn't connect Google Drive. Please try again."
    },
    errorFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.error-title",
        defaultMessage: "Connection failed"
    },
    errorFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.error-description",
        defaultMessage: "Something went wrong connecting Google Drive. Please try again."
    }
});
const $225bc84a53ca9cda$export$55683e4280ace85d = ({ unauthenticatedServices: unauthenticatedServices, onThirdPartyAuthRefetch: onThirdPartyAuthRefetch, spaceId: spaceId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const hasFiredRenderedRef = (0, $42omo.useRef)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const eligibleConnectors = (0, $42omo.useMemo)(()=>Object.keys(unauthenticatedServices), [
        unauthenticatedServices
    ]);
    const isRendered = !(0, $1I9Gw.isPersonalSpace)(spaceKey) && isVisible;
    (0, $42omo.useEffect)(()=>{
        if (isRendered && spaceId && !hasFiredRenderedRef.current) {
            hasFiredRenderedRef.current = true;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'curationEntry',
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        entryPoint: 'authEntry',
                        suggestionCount: 0,
                        eligibleConnectors: eligibleConnectors
                    }
                }
            }).fire();
        }
    }, [
        isRendered,
        spaceId,
        spaceKey,
        eligibleConnectors,
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'close_button'
                }
            }
        }).fire();
        dismissAction(false);
        setIsVisible(false);
    };
    const handleNeverShowAgain = ()=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'never_show_again'
                }
            }
        }).fire();
        dismissAction(true);
        setIsVisible(false);
    };
    const authUrl = unauthenticatedServices[(0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).GOOGLE_DRIVE]?.outboundAuthUrl;
    if ((0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || !authUrl) return null;
    const handleConnect = async (flags)=>{
        try {
            await (0, $3uVVG.auth)(authUrl);
            await onThirdPartyAuthRefetch();
            flags?.showSuccessFlag({
                id: 'space-curation.third-party-auth.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
        } catch (error) {
            if (error instanceof (0, $3uVVG.AuthError) && error.type === 'auth_window_closed') flags?.showWarningFlag({
                id: 'space-curation.third-party-auth.cancelled',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagDescription),
                isAutoDismiss: true
            });
            else flags?.showErrorFlag({
                id: 'space-curation.third-party-auth.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $225bc84a53ca9cda$var$styles.container,
            testId: "space-navigation-third-party-auth"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $225bc84a53ca9cda$var$styles.topRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $225bc84a53ca9cda$var$styles.mainAction,
            onClick: ()=>void handleConnect(flags)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc473e89fe15c58b$export$e16bd899bb4eebf9), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text"
        }, intl.formatMessage($225bc84a53ca9cda$var$i18n.title), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "accent-gray"
        }, intl.formatMessage($225bc84a53ca9cda$var$i18n.beta)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.link"
        }, intl.formatMessage($225bc84a53ca9cda$var$i18n.connect))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
            onDismiss: handleDismiss,
            onNeverShowAgain: handleNeverShowAgain
        }))));
};




const $4516149d204af1cd$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1yt4pxbi _bfhk1s93 _19pku2gc _kqswh2mm",
    topRow: "_1e0c1txw _4cvr1y6m _1bah1yb4 _otyr1b66",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    mainAction: "_zulp1b66 _1yt4ze3t _1e0c1txw _2lx21bp4 _4cvr1y6m _bfhk1j28 _1bsb1osq _y3gnv2br"
};
const $4516149d204af1cd$var$i18n = (0, $aXWIB.defineMessages)({
    addContent: {
        id: "space-curation.space-navigation.related-content.add-content",
        defaultMessage: "Add content that matters here from across your apps"
    },
    addContentSubtitle: {
        id: "space-curation.space-navigation.related-content.add-content-subtitle",
        defaultMessage: "Get organized with relevant files from your apps."
    },
    beta: {
        id: "space-curation.space-navigation.related-content.beta",
        defaultMessage: "Beta"
    },
    addContentAction: {
        id: "space-curation.space-navigation.related-content.add-content-action",
        defaultMessage: "Review and add"
    }
});
const $4516149d204af1cd$var$SpaceNavigationRelatedContentBody = ({ spaceKey: spaceKey, suggestionCount: suggestionCount, onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain, spaceId: spaceId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const pageTreeStateUpdaterRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const mountValuesRef = (0, $42omo.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        suggestionCount: suggestionCount,
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $42omo.useEffect)(()=>{
        const { spaceId: si, spaceKey: sk, suggestionCount: sc, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    entryPoint: 'suggestionsEntry',
                    suggestionCount: sc
                }
            }
        }).fire();
    }, []);
    const handleDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'close_button',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onDismiss();
    };
    const handleNeverShowAgain = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'never_show_again',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onNeverShowAgain();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4516149d204af1cd$var$styles.container,
        testId: "space-navigation-related-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4516149d204af1cd$var$styles.topRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4516149d204af1cd$var$styles.iconsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $83a4f2079077de9f$export$98526f0dffd4f41b), {
        variant: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
        onDismiss: handleDismiss,
        onNeverShowAgain: handleNeverShowAgain
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $4516149d204af1cd$var$styles.mainAction,
        onClick: ()=>setIsModalOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4516149d204af1cd$var$i18n.addContent), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "accent-gray"
    }, intl.formatMessage($4516149d204af1cd$var$i18n.beta))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.link",
        weight: "medium"
    }, intl.formatMessage($4516149d204af1cd$var$i18n.addContentAction)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0ce0b995765d610$export$c9ce09b966ffa4f7), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        onClose: ()=>setIsModalOpen(false),
        onSaveSuccess: ()=>{
            setIsModalOpen(false);
            if (pageTreeStateUpdaterRef.current) pageTreeStateUpdaterRef.current.setForceFetchPageId(spaceKey);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageTreeStateUpdater)=>{
        pageTreeStateUpdaterRef.current = pageTreeStateUpdater;
        return null;
    }));
};
const $4516149d204af1cd$export$8372b97ddec977cb = ({ spaceId: spaceId })=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const { count: count, isLoading: isLoadingCount, isSuppressed: isSuppressed } = (0, $862814430f69e6aa$export$ba9e49b520a30a69)(spaceKey);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { unauthenticatedServices: unauthenticatedServices, isLoading: isLoadingThirdPartyAuth, refetch: refetchThirdPartyAuth } = (0, $dddab7bf95955fb3$export$3d6949c2295aff10)({
        products: [
            (0, $9d3782c3b842cfbc$export$f0c7a43b2eefe22f).GOOGLE_DRIVE
        ],
        cloudId: cloudId
    });
    if (!spaceKey || (0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || isLoadingCount || isSuppressed) return null;
    if (!isLoadingCount && !isLoadingThirdPartyAuth && count === 0 && Object.keys(unauthenticatedServices).length != 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $225bc84a53ca9cda$export$55683e4280ace85d), {
        unauthenticatedServices: unauthenticatedServices,
        onThirdPartyAuthRefetch: refetchThirdPartyAuth,
        spaceId: spaceId
    });
    if (count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentBody, {
        spaceKey: spaceKey,
        suggestionCount: count,
        onDismiss: ()=>{
            dismissAction(false);
            setIsVisible(false);
        },
        onNeverShowAgain: ()=>{
            dismissAction(true);
            setIsVisible(false);
        },
        spaceId: spaceId
    });
};


const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete } = t0;
    const t1 = spaceKey || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            spaceKey: t1,
            operation: (0, $lfBMY.OperationTypes).CREATE,
            contentType: "page"
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const [canCreateContent] = (0, $2wo33.useCanPerformSpaceOperation)(t2);
    let t3;
    if ($[2] !== isSpaceAdmin || $[3] !== quick || $[4] !== showShortcutsSection || $[5] !== space?.id || $[6] !== spaceKey) {
        t3 = showShortcutsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04jMq.ShortcutsSection), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        });
        $[2] = isSpaceAdmin;
        $[3] = quick;
        $[4] = showShortcutsSection;
        $[5] = space?.id;
        $[6] = spaceKey;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== canCreateContent || $[9] !== homepageId || $[10] !== isBlogNavigation || $[11] !== loading || $[12] !== onContentTreeLoadComplete || $[13] !== onDragDropSuccess || $[14] !== pageTreeFinishedLoading || $[15] !== space?.didContainUserContent || $[16] !== space?.id || $[17] !== spaceKey) {
        t4 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree",
            onMouseEnter: (0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) ? undefined : (0, $3qtLb.PageTreeLoaderOnHover).hydrateOnHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            relatedContent: canCreateContent && (0, $6mKj3.expValEquals)("confluence_autonomous_space_curation", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4516149d204af1cd$export$8372b97ddec977cb), {
                spaceId: space?.id
            }) : null
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[8] = canCreateContent;
        $[9] = homepageId;
        $[10] = isBlogNavigation;
        $[11] = loading;
        $[12] = onContentTreeLoadComplete;
        $[13] = onDragDropSuccess;
        $[14] = pageTreeFinishedLoading;
        $[15] = space?.didContainUserContent;
        $[16] = space?.id;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== blogsHidden || $[20] !== loading || $[21] !== pageTreeFinishedLoading || $[22] !== spaceKey) {
        t5 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzS7A.BlogTree), {
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        });
        $[19] = blogsHidden;
        $[20] = loading;
        $[21] = pageTreeFinishedLoading;
        $[22] = spaceKey;
        $[23] = t5;
    } else t5 = $[23];
    let t6;
    if ($[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4, t5);
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    return t6;
};















var $1Zr9M = parcelRequire("1Zr9M");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $3gadb = parcelRequire("3gadb");


var $7Ri6A = parcelRequire("7Ri6A");








var $9x2sR = parcelRequire("9x2sR");








var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $eWwvy = parcelRequire("eWwvy");





var $dPJCf = parcelRequire("dPJCf");














var $jrref = parcelRequire("jrref");




var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $5ecc3f8934f85e59$exports = {};
$5ecc3f8934f85e59$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $db1162a25db39e60$exports = {};
$db1162a25db39e60$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $537a412b2964f6f0$exports = {};
$537a412b2964f6f0$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $a4e38a378b5824d3$exports = {};
$a4e38a378b5824d3$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();


const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($5ecc3f8934f85e59$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($db1162a25db39e60$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($537a412b2964f6f0$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($a4e38a378b5824d3$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        return (0, $dh538.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, spotlightCard));
    })())));
};












var $euUgw = parcelRequire("euUgw");







var $dcJ7R = parcelRequire("dcJ7R");









var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $ecnYn.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $ecnYn.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $ecnYn.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $aXWIB.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});















var $4kfV4 = parcelRequire("4kfV4");

















const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("9rzGl"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("9rzGl"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $frIzR.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null);
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $aXWIB.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("eYQg6"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $6f43a2e4204022e9$export$533fb76256978163 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let containsExternalCollaborators;
    let isExternalCollaborator;
    let props;
    if ($[0] !== t0) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, ...props } = t0);
        $[0] = t0;
        $[1] = containsExternalCollaborators;
        $[2] = isExternalCollaborator;
        $[3] = props;
    } else {
        containsExternalCollaborators = $[1];
        isExternalCollaborator = $[2];
        props = $[3];
    }
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    let t1;
    if ($[4] !== props || $[5] !== showExCoMessaging) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...props,
            showExCoMessaging: showExCoMessaging
        });
        $[4] = props;
        $[5] = showExCoMessaging;
        $[6] = t1;
    } else t1 = $[6];
    const header = t1;
    return header;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $frIzR.c)(41);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== showExCoMessaging || $[4] !== spaceKey) {
        t2 = showExCoMessaging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        })) : undefined;
        $[3] = showExCoMessaging;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $42omo.useState)(false);
    let t4;
    if ($[8] !== canManageSomeUsers || $[9] !== hasArchiveSpacePermission || $[10] !== hasDeleteSpacePermission || $[11] !== isMoreActionsOpen || $[12] !== isSpaceAdmin || $[13] !== isSpaceArchived || $[14] !== isStarred || $[15] !== isWatched || $[16] !== spaceId || $[17] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[8] = canManageSomeUsers;
        $[9] = hasArchiveSpacePermission;
        $[10] = hasDeleteSpacePermission;
        $[11] = isMoreActionsOpen;
        $[12] = isSpaceAdmin;
        $[13] = isSpaceArchived;
        $[14] = isStarred;
        $[15] = isWatched;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    const moreActionsMenu = t4;
    let t5;
    if ($[19] !== iconPath || $[20] !== isPersonalSpace || $[21] !== isSpaceAdmin || $[22] !== spaceId || $[23] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceId: spaceId,
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[19] = iconPath;
        $[20] = isPersonalSpace;
        $[21] = isSpaceAdmin;
        $[22] = spaceId;
        $[23] = spaceKey;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== description || $[26] !== isSelected || $[27] !== moreActionsMenu || $[28] !== onClick || $[29] !== spaceName || $[30] !== spaceOverviewHref || $[31] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[25] = description;
        $[26] = isSelected;
        $[27] = moreActionsMenu;
        $[28] = onClick;
        $[29] = spaceName;
        $[30] = spaceOverviewHref;
        $[31] = t5;
        $[32] = t6;
    } else t6 = $[32];
    let t7;
    if ($[33] !== spaceOverviewHref || $[34] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$RemovedSpotlightTarget, {
            name: "nav4-spotlight-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[33] = spaceOverviewHref;
        $[34] = t6;
        $[35] = t7;
    } else t7 = $[35];
    let t8;
    if ($[36] !== showExCoMessaging) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[36] = showExCoMessaging;
        $[37] = t8;
    } else t8 = $[37];
    let t9;
    if ($[38] !== t7 || $[39] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8);
        $[38] = t7;
        $[39] = t8;
        $[40] = t9;
    } else t9 = $[40];
    return t9;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { spaceId: spaceId, spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $7Ri6A.usePageLayoutResize)();
    const [isDialogOpen, setIsDialogOpen] = (0, $42omo.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1bsb1tcg _4t3i1tcg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== expandLeftSidebar || $[6] !== experienceTracker || $[7] !== leftSidebarState.isFlyoutOpen || $[8] !== spaceId || $[9] !== spaceKey) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    containerType: "space",
                    containerId: spaceId,
                    attributes: {
                        navVersion: 4,
                        entryPoint: "sideNav",
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = expandLeftSidebar;
        $[6] = experienceTracker;
        $[7] = leftSidebarState.isFlyoutOpen;
        $[8] = spaceId;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const onClick = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[11] = t4;
    } else t4 = $[11];
    const onFocus = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[12] = t5;
    } else t5 = $[12];
    const onMouseEnter = t5;
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[13] = t6;
    } else t6 = $[13];
    const onDialogOpen = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[14] = t7;
    } else t7 = $[14];
    const onDialogClose = t7;
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== editLabel || $[17] !== image || $[18] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[16] = editLabel;
        $[17] = image;
        $[18] = onClick;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== editLabel || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: editLabel
        }, t9);
        $[20] = editLabel;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== isDialogOpen || $[24] !== shouldRenderDialog || $[25] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose,
            entryPoint: "sideNav"
        });
        $[23] = isDialogOpen;
        $[24] = shouldRenderDialog;
        $[25] = spaceKey;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t10 || $[28] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[27] = t10;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $6f43a2e4204022e9$var$stickyWrapper = (0, $ecnYn.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $ecnYn.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $ecnYn.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qutpp _n3td1skh _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6f43a2e4204022e9$var$i18n = (0, $aXWIB.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});



var $ENihE = parcelRequire("ENihE");











var $euL71 = parcelRequire("euL71");











var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-native-link",
            onClick: sendItemClickedAnalytics("questions")
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== t2 || $[10] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: t3
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    const renderedLinks = t4;
    let t5;
    if ($[12] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderedLinks);
        $[12] = renderedLinks;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("eBq5a"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("8Ai3e"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return Boolean(link && !link.hidden);
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("4vXZ9"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("fMSLz"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $42omo.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n3tdze3t _kqswh2mm _19pk1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails } = t0;
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t1 = unhandledError || anonymousAccessQueryError;
        let t2;
        if ($[0] !== hasNotFoundError || $[1] !== hasRestrictedError || $[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t1,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[0] = hasNotFoundError;
            $[1] = hasRestrictedError;
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== spaceDetails) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), spaceDetails);
        $[4] = spaceDetails;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== loading) {
        t2 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[6] = loading;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== blogsHidden || $[9] !== homepageId || $[10] !== isBlogNavigation || $[11] !== isSpaceAdmin || $[12] !== loading || $[13] !== onContentTreeLoadComplete || $[14] !== onDragDropSuccess || $[15] !== pageTreeFinishedLoading || $[16] !== quick || $[17] !== showShortcutsSection || $[18] !== space || $[19] !== spaceKey) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72da3bb5b7695f3e$export$7716f65eb5d1a3fd), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete
        });
        $[8] = blogsHidden;
        $[9] = homepageId;
        $[10] = isBlogNavigation;
        $[11] = isSpaceAdmin;
        $[12] = loading;
        $[13] = onContentTreeLoadComplete;
        $[14] = onDragDropSuccess;
        $[15] = pageTreeFinishedLoading;
        $[16] = quick;
        $[17] = showShortcutsSection;
        $[18] = space;
        $[19] = spaceKey;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _vjgoze3t"
        ]);
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] !== loading || $[23] !== main) {
        t5 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[22] = loading;
        $[23] = main;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== t4 || $[26] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": "space-links",
            className: t4
        }, t5);
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    let t7;
    if ($[28] !== allAppLinks || $[29] !== allVisibleAppLinks || $[30] !== isSpaceAdmin || $[31] !== loading || $[32] !== loadingForgeApps || $[33] !== shouldRenderSpaceApps || $[34] !== spaceKey) {
        t7 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            isSpaceAdmin: isSpaceAdmin,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[28] = allAppLinks;
        $[29] = allVisibleAppLinks;
        $[30] = isSpaceAdmin;
        $[31] = loading;
        $[32] = loadingForgeApps;
        $[33] = shouldRenderSpaceApps;
        $[34] = spaceKey;
        $[35] = t7;
    } else t7 = $[35];
    let t8;
    if ($[36] !== t2 || $[37] !== t3 || $[38] !== t6 || $[39] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t2, t3, t6, t7);
        $[36] = t2;
        $[37] = t3;
        $[38] = t6;
        $[39] = t7;
        $[40] = t8;
    } else t8 = $[40];
    let t9;
    if ($[41] !== loading) {
        t9 = !loading && (0, $9wGTI.fg)("nav4_global_links_confluence") && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }));
        $[41] = loading;
        $[42] = t9;
    } else t9 = $[42];
    let t10;
    if ($[43] !== t1 || $[44] !== t8 || $[45] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t8, t9);
        $[43] = t1;
        $[44] = t8;
        $[45] = t9;
        $[46] = t10;
    } else t10 = $[46];
    return t10;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("04jMq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("ktWEj"))).ShortcutsSection
});
module.exports["ShortcutsSection"] = $16e27872478384c0$export$7f1bcb54a9a4d80e;

});

parcelRegister("ktWEj", function(module, exports) {

let $ee9402983f68697b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee9402983f68697b$var$load("1CUOt"),
    $ee9402983f68697b$var$load("etEYy"),
    $ee9402983f68697b$var$load("6wr18"),
    $ee9402983f68697b$var$load("fLZBc"),
    $ee9402983f68697b$var$load("bg5OF"),
    $ee9402983f68697b$var$load("lkQAE"),
    $ee9402983f68697b$var$load("hhss7"),
    $ee9402983f68697b$var$load("ffEVr"),
    $ee9402983f68697b$var$load("Wowvf"),
    $ee9402983f68697b$var$load("8W6BK"),
    $ee9402983f68697b$var$load("6VoH9"),
    $ee9402983f68697b$var$load("fNa2t"),
    $ee9402983f68697b$var$load("gYr8z"),
    $ee9402983f68697b$var$load("gepVN"),
    $ee9402983f68697b$var$load("cj0Rr"),
    $ee9402983f68697b$var$load("2QTNW"),
    $ee9402983f68697b$var$load("7tgvK"),
    $ee9402983f68697b$var$load("eM6Cm"),
    $ee9402983f68697b$var$load("7EorR"),
    $ee9402983f68697b$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("3qtLb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $1xpoY = parcelRequire("1xpoY");


var $5Abqh = parcelRequire("5Abqh");


var $6mKj3 = parcelRequire("6mKj3");

const $674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("27n42"))).PageTree
});

const $674e09754a51af28$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "dXqjD",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("27n42"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1xpoY.default).getNumber($674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        $[0] = t0;
    } else t0 = $[0];
    const delayHydrationOnHoverTimeout = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !(0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) && delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTreeLoaderOnHover"] = $674e09754a51af28$export$8ce7795bff922b41;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("27n42", function(module, exports) {

let $18ae20455a35aa8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $18ae20455a35aa8b$var$load("jhgNc"),
    $18ae20455a35aa8b$var$load("ijAU0"),
    $18ae20455a35aa8b$var$load("1WCMN"),
    $18ae20455a35aa8b$var$load("eY7q8"),
    $18ae20455a35aa8b$var$load("6wr18"),
    $18ae20455a35aa8b$var$load("e4XZ1"),
    $18ae20455a35aa8b$var$load("5ppK3"),
    $18ae20455a35aa8b$var$load("an06t"),
    $18ae20455a35aa8b$var$load("6ZWAd"),
    $18ae20455a35aa8b$var$load("4mgLr"),
    $18ae20455a35aa8b$var$load("19uFC"),
    $18ae20455a35aa8b$var$load("28l1x"),
    $18ae20455a35aa8b$var$load("iNa18"),
    $18ae20455a35aa8b$var$load("ffEVr"),
    $18ae20455a35aa8b$var$load("gepVN"),
    $18ae20455a35aa8b$var$load("cj0Rr"),
    $18ae20455a35aa8b$var$load("2QTNW"),
    $18ae20455a35aa8b$var$load("kFiBp"),
    $18ae20455a35aa8b$var$load("hhss7"),
    $18ae20455a35aa8b$var$load("Wowvf"),
    $18ae20455a35aa8b$var$load("7EorR"),
    $18ae20455a35aa8b$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("k5uAm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");


var $jsQN1 = parcelRequire("jsQN1");

const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $jsQN1.useHoverPageCardsOptStatus)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $42omo.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $42omo.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $42omo.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $42omo.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};
module.exports["useHoverPageCard"] = $f35e894e447c6262$export$3bba19b3f6dc31cd;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("jsQN1", function(module, exports) {

var $4Tg4P = parcelRequire("4Tg4P");


var $bQm3c = parcelRequire("bQm3c");


var $5xaHK = parcelRequire("5xaHK");


var $jMyy4 = parcelRequire("jMyy4");

const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $4Tg4P.default);
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed,
        __callerPackage__: "@confluence/page-card"
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $5xaHK.PageCardInPageTreeHoverPreference).NO_SHOW_PAGECARD
    };
};
module.exports["useHoverPageCardsOptStatus"] = $2d41bbac85093ab1$export$f824d805fc04fcb2;

});

parcelRegister("4Tg4P", function(module, exports) {
/**
 * @generated SignedSource<<5dba3a144ab42cf95f6adf8ddd214d30>>
 * @relayHash d1f433c5859a639556bc75700750a999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006
const $48c38c534b125c22$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "shouldShowCardOnPageTreeHover"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f433c5859a639556bc75700750a999",
            "id": "120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006",
            "metadata": {},
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "operationKind": "query",
            "text": "query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}"
        }
    };
}();
$48c38c534b125c22$var$node.hash = "1e92ca51a019c1c7e4b73556b6c593ea";
var $48c38c534b125c22$export$2e2bcd8739ae039 = $48c38c534b125c22$var$node;
module.exports["default"] = $48c38c534b125c22$export$2e2bcd8739ae039;

});

parcelRegister("5xaHK", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});
module.exports["PageCardInPageTreeHoverPreference"] = $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "@confluence/super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<addb5e142aa82e94041daec88a20b086>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "@confluence/space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_USERS"] = $981a614bc39b93a3$export$42add616309f8ea4;
module.exports["MANAGE_NONLICENSED_USERS"] = $981a614bc39b93a3$export$ceb95831d69da149;
module.exports["MANAGE_GUEST_USERS"] = $981a614bc39b93a3$export$3eb61eb33a05d6fe;
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<538ddf86109b083feb03880ace3dfe2d>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t0,
        __callerPackage__: "@confluence/space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<312885e46175f1caad2e8c88a205c3bc>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("j3kZx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $42omo.useState)();
    const isDefaultExpanded = (0, $42omo.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $42omo.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("gCFsY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("fWnGm"))).SpaceHoverPageCard
});
module.exports["LazySpaceHoverPageCard"] = $d9810ba2fa073e42$export$d09f0ee316c3b5c1;

});

parcelRegister("fWnGm", function(module, exports) {

let $b9aea492f95d28e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b9aea492f95d28e2$var$load("kqCaX"),
    $b9aea492f95d28e2$var$load("3Th6e"),
    $b9aea492f95d28e2$var$load("6wr18"),
    $b9aea492f95d28e2$var$load("4dNRa"),
    $b9aea492f95d28e2$var$load("3R2Cd"),
    $b9aea492f95d28e2$var$load("1GCFv"),
    $b9aea492f95d28e2$var$load("1H5IN"),
    $b9aea492f95d28e2$var$load("a9w2G"),
    $b9aea492f95d28e2$var$load("k2R9e"),
    $b9aea492f95d28e2$var$load("7kkP6"),
    $b9aea492f95d28e2$var$load("5CkG5"),
    $b9aea492f95d28e2$var$load("j1p8s"),
    $b9aea492f95d28e2$var$load("h4Nf7"),
    $b9aea492f95d28e2$var$load("hv4mn"),
    $b9aea492f95d28e2$var$load("jbxHq"),
    $b9aea492f95d28e2$var$load("l0dTs"),
    $b9aea492f95d28e2$var$load("hhss7"),
    $b9aea492f95d28e2$var$load("cyGuT"),
    $b9aea492f95d28e2$var$load("ffEVr"),
    $b9aea492f95d28e2$var$load("gYr8z"),
    $b9aea492f95d28e2$var$load("cj0Rr"),
    $b9aea492f95d28e2$var$load("kFiBp"),
    $b9aea492f95d28e2$var$load("7EorR"),
    $b9aea492f95d28e2$var$load("Wowvf"),
    $b9aea492f95d28e2$var$load("etEYy"),
    $b9aea492f95d28e2$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<894f0475d89546b8f8ba914dd859e916>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<c8387b882d3435676c14c949ef15aace>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $aXWIB.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified",
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isLicensed,
        __callerPackage__: "@confluence/space-views"
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation, {
        __callerPackage__: "@confluence/space-views"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/space-views"
    });
    const setSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: queryLoading,
        queryError: queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30b71203151c57c81eb934d688fd9be6>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c4de3c3a60bbeec4$var$buttonStyle = null;
const $c4de3c3a60bbeec4$var$menuButtonIconColor = (isWhiteboardBetaEnabled)=>{
    return isWhiteboardBetaEnabled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$266a769812832828 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_s1xtjf": (0, $7sObp.default)($c4de3c3a60bbeec4$var$menuButtonIconColor(__cmplp.isWhiteboardBetaEnabled))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _bfhk1j28 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _i2zu1q3r _19lcplhp",
            __cmplp.isOpen ? "_1efs18pu" : "_1efsdgkc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8wadc _ca0qt94y _u5f31l7b _n3tdt94y _19bv1l7b _bfhki8nm _syazi7uo _k48pwu06",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$11b902a59791d036 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8wo40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$851411cf794a4cc4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1y44 _2hwx1y44 _otyr1y44 _18u0ftgi _2rko1rr0 _1yt418iy _19itglyw _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _bfhk1s93 _syaz1oa5 _1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _18s817d0 _11c8fhey _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _4t3imgvx _syazi7uo",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("lCzuN", function(module, exports) {

let $fbd8ae4f6cd97366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fbd8ae4f6cd97366$var$load("kHOMt"),
    $fbd8ae4f6cd97366$var$load("eM6Cm"),
    $fbd8ae4f6cd97366$var$load("kFiBp"),
    $fbd8ae4f6cd97366$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("4L0Wn", function(module, exports) {

let $376c480054600106$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $376c480054600106$var$load("hhss7"),
    $376c480054600106$var$load("6pr2g"),
    $376c480054600106$var$load("15N8O"),
    $376c480054600106$var$load("QDkFg"),
    $376c480054600106$var$load("daX4F"),
    $376c480054600106$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("b7lZG", function(module, exports) {

let $818168af2f2c4166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $818168af2f2c4166$var$load("kJLy8"),
    $818168af2f2c4166$var$load("4mgLr"),
    $818168af2f2c4166$var$load("hhss7"),
    $818168af2f2c4166$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("jzS7A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("5hc6n"))).BlogTree
});
module.exports["BlogTree"] = $2956b96ada85ef60$export$a2e535ad780a85fe;

});

parcelRegister("5hc6n", function(module, exports) {

let $3d77ed6fd4ea6e71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d77ed6fd4ea6e71$var$load("aq5NX"),
    $3d77ed6fd4ea6e71$var$load("6wr18"),
    $3d77ed6fd4ea6e71$var$load("e4XZ1"),
    $3d77ed6fd4ea6e71$var$load("5ppK3"),
    $3d77ed6fd4ea6e71$var$load("lkQAE"),
    $3d77ed6fd4ea6e71$var$load("hhss7"),
    $3d77ed6fd4ea6e71$var$load("iNa18"),
    $3d77ed6fd4ea6e71$var$load("ffEVr"),
    $3d77ed6fd4ea6e71$var$load("e1RjR"),
    $3d77ed6fd4ea6e71$var$load("cj0Rr"),
    $3d77ed6fd4ea6e71$var$load("2QTNW"),
    $3d77ed6fd4ea6e71$var$load("kFiBp"),
    $3d77ed6fd4ea6e71$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("7Ri6A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jZM59 = parcelRequire("jZM59");

const $4f1b92ba2c91b695$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)((0, $jZM59.SidebarResizeContext));
    return context;
};
module.exports["usePageLayoutResize"] = $4f1b92ba2c91b695$export$10c7104037a7af62;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
module.exports["SidebarResizeContext"] = $e6220385bdb59eee$export$aa5a712eea4c2ae8;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $aXWIB.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("9rzGl", function(module, exports) {

let $6e02505dc0bebec2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6e02505dc0bebec2$var$load("aq5NX"),
    $6e02505dc0bebec2$var$load("6wr18"),
    $6e02505dc0bebec2$var$load("hHrTM"),
    $6e02505dc0bebec2$var$load("ffEVr"),
    $6e02505dc0bebec2$var$load("e1RjR"),
    $6e02505dc0bebec2$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("eYQg6", function(module, exports) {

let $ae7f34c709c89a0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae7f34c709c89a0f$var$load("2Tk6L"),
    $ae7f34c709c89a0f$var$load("6oFhK")
]).then(()=>parcelRequire('iwt54'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;

});

parcelRegister("eBq5a", function(module, exports) {

let $aa18c0cad27925d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa18c0cad27925d9$var$load("6wr18"),
    $aa18c0cad27925d9$var$load("ffEVr"),
    $aa18c0cad27925d9$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("8Ai3e", function(module, exports) {

let $63ffb01b27107377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ffb01b27107377$var$load("6wr18"),
    $63ffb01b27107377$var$load("ffEVr"),
    $63ffb01b27107377$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("4vXZ9", function(module, exports) {

let $34989688401e1317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34989688401e1317$var$load("6wr18"),
    $34989688401e1317$var$load("ffEVr"),
    $34989688401e1317$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("fMSLz", function(module, exports) {

let $b7e5d2279b3c95b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7e5d2279b3c95b2$var$load("6wr18"),
    $b7e5d2279b3c95b2$var$load("ffEVr"),
    $b7e5d2279b3c95b2$var$load("e1RjR"),
    $b7e5d2279b3c95b2$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("h2zCi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $2f41a78c0ed289bb$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $2f41a78c0ed289bb$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $2f41a78c0ed289bb$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $2f41a78c0ed289bb$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$2f41a78c0ed289bb$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $2f41a78c0ed289bb$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $2f41a78c0ed289bb$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $2f41a78c0ed289bb$export$9942248a1ae255c2 = ({ children: children, ...props })=>{
    const resizing = $2f41a78c0ed289bb$export$a300664a1a230956(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizing"] = $2f41a78c0ed289bb$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $frIzR.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "@confluence/restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "@confluence/restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<54b68d5aa1c95b977f0cb84ddd5a4477>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $eG1e2 = parcelRequire("eG1e2");


var $5tmwS = parcelRequire("5tmwS");


var $g5QRf = parcelRequire("g5QRf");


var $e0ycV = parcelRequire("e0ycV");


var $5YfNL = parcelRequire("5YfNL");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: // can override default icon color
spacing, type: type, isExpanded: isExpanded = false, isMarkdownMode: isMarkdownMode = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        slide: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: isMarkdownMode ? (0, $5YfNL.PageMarkdownIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});


//# sourceMappingURL=SpaceNavigationContent.d5d3ce97.js.map
